import React, { useState, useMemo, useEffect, useRef, useContext } from 'react';
import { Layout } from './Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from './ui/breadcrumb';
import { Checkbox } from './ui/checkbox';
import { PaginationCustom } from './ui/pagination-custom';
import {
  Users,
  Plus,
  Search,
  Filter,
  UserCheck,
  UserX,
  Edit,
  Trash2,
  Shield,
  Eye,
  EyeOff,
  Mail,
  Phone,
  Calendar,
  Clock,
  AlertTriangle,
  CheckCircle,
  Home,
  Settings,
  Download,
  Upload,
  MoreHorizontal,
  Lock,
  Unlock,
  RefreshCw,
  Copy,
  Save,
  X,
  Activity
} from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';
import { toast } from 'sonner';
import { useAuth } from './AuthContext';
import LoadingTable from './LoadingTable';
import { error } from 'console';
import { AppContext } from '@/App';
import { Alert, AlertDescription } from './ui/alert';
import { useDebounce } from '@/hooks/debounce';

// User role definitions
// export type UserRole = 'super_admin' | 'admin' | 'audit_manager' | 'senior_auditor' | 'auditor' | 'supervisor' | 'viewer';

export interface Permission {
  id: string;
  name: string;
  description: string;
  category: 'USERS' | 'PROMPTS' | 'AUDITS' | 'ROLES';
  isCustom?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  roleCount: number,
  module: string,
  action: string
}

export interface Role {

  id: string;
  name: string;
  displayName: string;
  description: string;
  permissions: string[];
  color: string;
  isCustom?: boolean;
  userCount?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  // department: string;
  isActive: boolean;
  lastLogin?: Date;
  createdAt: Date;
  updatedAt: Date;
  phone?: string;
  failedLoginAttempts: number;
  isLocked: boolean;
  requiresPasswordReset: boolean;
  twoFactorEnabled: boolean;
  total: number;
}

export interface UserRole {
  assignedAt: string;
  displayName: string;
  id: string;
  name: string;
}
type Pagination = {
  page: number;
  limit: number;
  total: number;
  pages: number;
};

// export interface User {
//   id: string;
//   email: string;
//   firstName: string;
//   lastName: string;
//   phone?: string | null;
//   isActive: boolean;
//   isLocked: boolean;
//   createdAt: Date;
//   updatedAt: Date;
//   // deletedAt?: string | null;
//   role: string; // ✅ updated from role: string
//   department: string;
//   failedLoginAttempts: number;
//   requiresPasswordReset: boolean;
//   twoFactorEnabled: boolean;
// }



// // Initial permissions data
// const initialPermissions: Permission[] = [
//   // System permissions
//   { id: 'system.admin', name: 'System Administration', description: 'Full system access and configuration', category: 'system' },
//   { id: 'system.settings', name: 'System Settings', description: 'Modify system-wide settings', category: 'system' },
//   { id: 'system.backup', name: 'System Backup', description: 'Perform system backups and restores', category: 'system' },

//   // User permissions
//   { id: 'user.create', name: 'Create Users', description: 'Create new user accounts', category: 'user' },
//   { id: 'user.edit', name: 'Edit Users', description: 'Modify existing user accounts', category: 'user' },
//   { id: 'user.delete', name: 'Delete Users', description: 'Delete user accounts', category: 'user' },
//   { id: 'user.view', name: 'View Users', description: 'View user accounts and profiles', category: 'user' },
//   { id: 'user.roles', name: 'Manage Roles', description: 'Assign and modify user roles', category: 'user' },

//   // Audit permissions
//   { id: 'audit.create', name: 'Create Audits', description: 'Create new audit records', category: 'audit' },
//   { id: 'audit.edit', name: 'Edit Audits', description: 'Modify audit records', category: 'audit' },
//   { id: 'audit.approve', name: 'Approve Audits', description: 'Approve or reject audit findings', category: 'audit' },
//   { id: 'audit.view', name: 'View Audits', description: 'View audit records and findings', category: 'audit' },
//   { id: 'audit.delete', name: 'Delete Audits', description: 'Delete audit records', category: 'audit' },
//   { id: 'audit.override', name: 'Override Decisions', description: 'Override audit decisions and recommendations', category: 'audit' },

//   // Report permissions
//   { id: 'report.view', name: 'View Reports', description: 'Access audit reports and analytics', category: 'report' },
//   { id: 'report.create', name: 'Create Reports', description: 'Generate custom reports', category: 'report' },
//   { id: 'report.export', name: 'Export Reports', description: 'Export reports and data', category: 'report' },
// ];

// // Initial roles data
// const initialRoles: Role[] = [
//   {
//     id: 'super_admin',
//     name: 'Super Administrator',
//     description: 'Full system access with all permissions',
//     permissions: initialPermissions.map(p => p.id),
//     color: 'bg-red-100 text-red-800',
//     userCount: 0
//   },
//   {
//     id: 'admin',
//     name: 'Administrator',
//     description: 'Administrative access without system configuration',
//     permissions: [
//       'user.create', 'user.edit', 'user.view', 'user.roles',
//       'audit.view', 'audit.create', 'audit.edit', 'audit.approve',
//       'report.view', 'report.create', 'report.export'
//     ],
//     color: 'bg-purple-100 text-purple-800',
//     userCount: 0
//   },
//   {
//     id: 'audit_manager',
//     name: 'Audit Manager',
//     description: 'Oversee audit processes and manage audit teams',
//     permissions: [
//       'audit.view', 'audit.create', 'audit.edit', 'audit.approve', 'audit.override',
//       'report.view', 'report.create', 'report.export',
//       'user.view'
//     ],
//     color: 'bg-blue-100 text-blue-800',
//     userCount: 0
//   },
//   {
//     id: 'senior_auditor',
//     name: 'Senior Auditor',
//     description: 'Perform audits and review junior auditor work',
//     permissions: [
//       'audit.view', 'audit.create', 'audit.edit', 'audit.approve',
//       'report.view', 'report.create'
//     ],
//     color: 'bg-green-100 text-green-800',
//     userCount: 0
//   },
//   {
//     id: 'auditor',
//     name: 'Auditor',
//     description: 'Perform basic audit functions',
//     permissions: [
//       'audit.view', 'audit.create', 'audit.edit',
//       'report.view'
//     ],
//     color: 'bg-yellow-100 text-yellow-800',
//     userCount: 0
//   },
//   {
//     id: 'supervisor',
//     name: 'Supervisor',
//     description: 'Review and approve audit findings',
//     permissions: [
//       'audit.view', 'audit.approve',
//       'report.view'
//     ],
//     color: 'bg-indigo-100 text-indigo-800',
//     userCount: 0
//   },
//   {
//     id: 'viewer',
//     name: 'Viewer',
//     description: 'Read-only access to audit data and reports',
//     permissions: [
//       'audit.view',
//       'report.view'
//     ],
//     color: 'bg-gray-100 text-gray-800',
//     userCount: 0
//   }
// ];



// Generate mock users with more data for better pagination testing
// const generateMockUsers = (): User[] => {
//   const departments = ['Audit', 'Quality Assurance', 'Compliance', 'IT', 'Administration'];
//   const firstNames = ['John', 'Sarah', 'Michael', 'Lisa', 'David', 'Jennifer', 'Robert', 'Amanda', 'James', 'Emily', 'Daniel', 'Michelle', 'Christopher', 'Ashley', 'Matthew', 'Jessica', 'Anthony', 'Samantha', 'Mark', 'Nicole', 'Donald', 'Elizabeth', 'Steven', 'Megan', 'Paul', 'Rachel'];
//   const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez'];

//   const users: User[] = [];

//   // Generate 75 users for better pagination testing
//   for (let i = 0; i < 75; i++) {
//     const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
//     const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
//     const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@healthcareaudit.com`;
//     const randomRole = initialRoles[Math.floor(Math.random() * initialRoles.length)].id;

//     users.push({
//       id: `user-${i + 1}`,
//       email,
//       firstName,
//       lastName,
//       role: randomRole,
//       department: departments[Math.floor(Math.random() * departments.length)],
//       isActive: Math.random() > 0.1, // 90% active
//       lastLogin: Math.random() > 0.3 ? new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000) : undefined,
//       createdAt: new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000),
//       updatedAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000),
//       phone: Math.random() > 0.3 ? `+1 (555) ${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 9000) + 1000}` : undefined,
//       failedLoginAttempts: Math.floor(Math.random() * 3),
//       isLocked: Math.random() > 0.95,
//       requiresPasswordReset: Math.random() > 0.9,
//       twoFactorEnabled: Math.random() > 0.4
//     });
//   }

//   return users;
// };

export function UserManagement() {
  const { user, token } = useAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [pagination, setPagination] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // const [selectedPermissions, setSelectedPermissions] = useState<
  //   { id: string; action: string }[]
  // >([]);

  // PAGINATION STATES - User Table
  // const [currentPage, setCurrentPage] = useState(1);
  // const [itemsPerPage, setItemsPerPage] = useState(15); // Changed default to 10 for better demonstration
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState<any>();
  const itemsPerPage = 10;
  const totalItems = paginationData?.total || users.length;
  const totalPages =
    paginationData?.pages || Math.ceil((users.length || 0) / itemsPerPage);

  // Pagination states for other tables
  const [rolesPage, setRolesPage] = useState(1);
  const [rolesPerPage, setRolesPerPage] = useState(15);
  const [permissionsPage, setPermissionsPage] = useState(1);
  const [permissionsPerPage, setPermissionsPerPage] = useState(15);

  // Filter states
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [selectedRole, setSelectedRole] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [permissionCategories, setPermissionCategories] = useState<any[]>([]);

  // Role management states
  const [roleSearchTerm, setRoleSearchTerm] = useState('');
  const [permissionSearchTerm, setPermissionSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  // Dialog states
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState<User | null>(null);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [viewUserData, setViewUserData] = useState<User | null>(null);
  const [showViewDialog, setShowViewDialog] = useState(false);

  // Role dialog states
  const [showCreateRoleDialog, setShowCreateRoleDialog] = useState(false);
  const [showEditRoleDialog, setShowEditRoleDialog] = useState(false);
  const [selectedRoleForEdit, setSelectedRoleForEdit] = useState<Role | null>(null);
  const [showDeleteRoleDialog, setShowDeleteRoleDialog] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState<Role | null>(null);
  const [viewRoleData, setViewRoleData] = useState<Role | null>(null);
  const [showViewRoleDialog, setShowViewRoleDialog] = useState(false);

  // Permission dialog states
  const [showCreatePermissionDialog, setShowCreatePermissionDialog] = useState(false);
  const [showEditPermissionDialog, setShowEditPermissionDialog] = useState(false);
  const [selectedPermissionForEdit, setSelectedPermissionForEdit] = useState<Permission | null>(null);
  const [showDeletePermissionDialog, setShowDeletePermissionDialog] = useState(false);
  const [permissionToDelete, setPermissionToDelete] = useState<Permission | null>(null);

  const { sideBarItems, setCurrentView } = useContext(AppContext);

  console.log('SideBarItems in UserManagement:', sideBarItems);
  const [showPassword, setShowPassword] = React.useState(false);

  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    locked: 0,
    requirePasswordReset: 0
  });
  const [roleValidationErrors, setRoleValidationErrors] = useState({
    name: '',
    displayName: '',
    description: '',
    permissionIds: ''
  });
  const resetValidationErrors = () => {
    setRoleValidationErrors({
      name: '',
      displayName: '',
      description: '',
      permissionIds: ''
    });
  };

  const [validationErrors, setValidationErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    roleIds: '',
    password: ''
  });

  //Reset Validation 
  const initialValidationErrors = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    roleIds: '',
    password: ''
  };
  const clearValidationErrors = () => {
    setValidationErrors(initialValidationErrors);
  };


  const existingEmails = users
    .filter(user => user.email)
    .map(user => user.email.toLowerCase());

  const isDuplicateEmail = (email: string): boolean => {
    return existingEmails.includes(email.toLowerCase());
  };



  // Validation function
  const validateForm = () => {
    const errors: any = {};

    // First Name (required)
    if (!formData.firstName.trim()) {
      errors.firstName = 'First name is required';
    } else if (formData.firstName.length < 2 || formData.firstName.length > 50) {
      errors.firstName = 'First name must be between 2 and 50 characters';
    } else if (!/^[a-zA-Z0-9]+$/.test(formData.firstName)) {
      errors.firstName = 'First name must contain only alphanumeric characters';
    } else if (/^\d+$/.test(formData.firstName)) {
      errors.firstName = 'First name cannot be only numbers';
    } else if (/^[^a-zA-Z0-9]+$/.test(formData.firstName)) {
      errors.firstName = 'First name cannot be only special characters';
    }

    // Last Name (optional)
    if (!formData.lastName.trim()) {
      errors.lastName = "Last name is required";
    } else if (formData.lastName.length < 2 || formData.lastName.length > 50) {
      errors.lastName = 'Last name must be between 2 and 50 characters';
    } else if (!/^[a-zA-Z0-9]+$/.test(formData.lastName)) {
      errors.lastName = 'Last name must contain only alphanumeric characters';
    } else if (/^\d+$/.test(formData.lastName)) {
      errors.lastName = 'Last name cannot be only numbers';
    } else if (/^[^a-zA-Z0-9]+$/.test(formData.lastName)) {
      errors.lastName = 'Last name cannot be only special characters';
    }


    // Email (required)
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
    } else if (isDuplicateEmail(formData.email)) {
      errors.email = 'Email already exists';
    }

    // Phone Number (optional)
    const phoneRegex = /^(?:\+1)?[2-9][0-9]{9}$/;
    if (formData.phoneNumber?.trim()) {
      if (!phoneRegex.test(formData.phoneNumber)) {
        errors.phoneNumber = 'Enter a valid phone number';
      }
    }

    // Password (required)
    if (!formData.password.trim()) {
      errors.password = 'Password is required';
    } else if (formData.password.length < 8 || formData.password.length > 32) {
      errors.password = 'Password must be between 8 and 32 characters';
    } else {
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,32}$/;
      if (!passwordRegex.test(formData.password)) {
        errors.password =
          'Password must include uppercase, lowercase, number, and special character';
      }
    }

    // Role IDs (required)
    if (!formData.roleIds || formData.roleIds.length === 0 || !formData.roleIds[0]) {
      errors.roleIds = 'Please select the role';
    }

    setValidationErrors(errors);
    return Object.values(errors).every((error) => error === '');
  };



  const handleInputChange = (field: any, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    if (validationErrors[field]) {
      setValidationErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handlePhoneChange = (value: any) => {
    const numbersOnly = value.replace(/\D/g, '');
    const limitedValue = numbersOnly.slice(0, 10);
    setFormData(prev => ({ ...prev, phoneNumber: limitedValue }));
    if (validationErrors.phoneNumber) {
      setValidationErrors(prev => ({ ...prev, phoneNumber: '' }));
    }
  };
  const validateRoleForm = () => {
    const errors = {
      name: "",
      displayName: "",
      description: "",
      permissionIds: ""
    };

    // // 🔹 Role Name Validation (3–50 characters)
    // if (!roleFormData.name.trim()) {
    //   errors.name = "Role name is required";
    // } else if (roleFormData.name.length < 2 || roleFormData.name.length > 50) {
    //   errors.name = "Role name must be between 2 and 50 characters";
    // }

    // // 🔹 Display Name Validation (3–50 characters)
    // if (!roleFormData.displayName.trim()) {
    //   errors.displayName = "Display name is required";
    // } else if (roleFormData.displayName.length < 2 || roleFormData.displayName.length > 50) {
    //   errors.displayName = "Display name must be between 2 and 50 characters";
    // }


    // 🔹 Description Validation (required, max 255 chars)
    // if (!roleFormData.description.trim()) {
    //   errors.description = "Description is required";
    // } else if (roleFormData.description.length < 5 || roleFormData.description.length > 250) {
    //   errors.description = "Description must be between 5 and 250 characters";
    // }




    // 🔹 Role Name Validation
    const name = roleFormData.name.trim();
    if (!name) {
      errors.name = "Role name is required";
    } else if (name.length < 2 || name.length > 50) {
      errors.name = "Role name must be between 2 and 50 characters";
    } else if (/^\d+$/.test(name)) {
      errors.name = "Role name cannot be only numbers";
    } else if (/^[^a-zA-Z0-9]+$/.test(name)) {
      errors.name = "Role name cannot be only special characters";
    } else if (!/^[A-Za-z]/.test(name)) {
      errors.name = "Role name must start with a letter";
    }

    // 🔹 Display Name Validation
    const displayName = roleFormData.displayName.trim();
    if (!displayName) {
      errors.displayName = "Display name is required";
    } else if (displayName.length < 2 || displayName.length > 50) {
      errors.displayName = "Display name must be between 2 and 50 characters";
    } else if (/^\d+$/.test(displayName)) {
      errors.displayName = "Display name cannot be only numbers";
    } else if (/^[^a-zA-Z0-9]+$/.test(displayName)) {
      errors.displayName = "Display name cannot be only special characters";
    } else if (!/^[A-Za-z]/.test(displayName)) {
      errors.displayName = "Display name must start with a letter";
    }


    // 🔹 Description Validation (required, 5–250 chars, alphanumeric)
    const description = roleFormData.description.trim();
    if (!description) {
      errors.description = "Description is required";
    } else if (description.length < 5 || description.length > 250) {
      errors.description = "Description must be between 5 and 250 characters";
    } else if (/^\d+$/.test(description)) {
      errors.description = "Description cannot be only numbers";
    } else if (/^[^a-zA-Z0-9]+$/.test(description)) {
      errors.description = "Description cannot be only special characters";
    }


    // 🔹 PermissionIds Validation (required)
    if (!roleFormData.permissionIds || roleFormData.permissionIds.length === 0) {
      errors.permissionIds = "At least one permission is required";
    }

    // Save errors to state
    setRoleValidationErrors(errors);

    // ✅ Return true only if no errors
    return Object.values(errors).every(error => error === "");
  };


  // Fetch Permissions
  const fetchPermissions = async (searchTerm = '', category = 'all') => {
    // setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (searchTerm) queryParams.append('search', searchTerm);
      if (category && category !== 'all') queryParams.append('module', category);

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}permissions?${queryParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Request failed');

      setPermissions(data?.permissions);
      return data;
    } catch (error: any) {
      console.error('Fetch error:', error.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch Permission Categories
  const fetchPermissionCategory = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}permissions/modules`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Request failed');
      setPermissionCategories(data?.modules);
      return data;
    } catch (error: any) {
      console.error('Fetch error:', error.message);
      return null;
    }
  };

  //Fetch Roles
  const fetchRoles = async (searchTerm = '') => {
    // setIsLoading(true);
    try {
      let url = `${import.meta.env.VITE_API_URL}roles`;

      if (searchTerm) {
        url += `?search=${encodeURIComponent(searchTerm)}`;
      }
      const response = await fetch(
        url,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        }
      );

      const data2 = await response.json();

      if (!response.ok) {
        throw new Error(data2.error || 'Request failed');
      }

      setRoles(data2?.roles);
      return data2;
    } catch (error: any) {
      // toast.error(error.message);
      console.error('Fetch error:', error.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  //Fetch Users
  const isFirstLoad = useRef(true);
  // const fetchUsers = async (showLoader = false) => {
  //   if (showLoader) {
  //     setIsLoading(true);
  //   }

  //   // let filteredUsers: User[] = [];
  //   // let allUsers: User[] = [];

  //   try {
  //     //   let page = 1;
  //     //   let totalPages = 1;
  //     //   do {
  //     //     const params = new URLSearchParams({
  //     //       page: page.toString(),
  //     //       ...(searchTerm ? { search: searchTerm } : {}),
  //     //       ...(selectedRole && selectedRole !== 'all' ? { role: selectedRole } : {}),
  //     //       ...(selectedStatus && selectedStatus !== 'all' ? { status: selectedStatus } : {}),
  //     //     });

  //     //     const response = await fetch(`${import.meta.env.VITE_API_URL}users?${params.toString()}`, {
  //     //       method: 'GET',
  //     //       headers: {
  //     //         'Content-Type': 'application/json',
  //     //         'Authorization': `Bearer ${token}`,
  //     //       },
  //     //     });

  //     //     const data = await response.json();
  //     //     if (!response.ok) {
  //     //       throw new Error(data.error || 'Failed to fetch filtered users');
  //     //     }

  //     //     filteredUsers = [...filteredUsers, ...(data?.users ?? [])];
  //     //     totalPages = data?.pagination?.pages || 1;
  //     //     page++;
  //     //   } while (page <= totalPages);
  //     //   setUsers(filteredUsers);

  //     let page = 1;
  //     // let  totalPages = 1;
  //     // do {
  //     const params = new URLSearchParams({ page: page.toString() });

  //     const response = await fetch(`${import.meta.env.VITE_API_URL}users?${params.toString()}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`,
  //       },
  //     });

  //     const data = await response.json();
  //     if (!response.ok) {

  //       throw new Error(data.error || 'Failed to fetch all users');
  //     }

  //     // allUsers = [...allUsers, ...(data?.users ?? [])];
  //     // totalPages = data?.pagination?.pages || 1;
  //     // page++;
  //     // } while (page <= totalPages);

  //     const pagination = data?.pagination
  //     // const activeUsers = allUsers.filter(user => user.isActive);
  //     // // const inactiveUsers = allUsers.filter(user => user.isLocked);
  //     // const inactiveUsers = allUsers.filter(user => !user.isActive);
  //     // const requirePasswordReset = allUsers.filter(user => user.requiresPasswordReset);

  //     console.log('Pagination:', pagination);
  //     setStats({
  //       total: pagination.totalUsers || 100,
  //       active: pagination.activeUsers,
  //       locked: pagination.inActiveUsers,
  //       requirePasswordReset: 0,
  //     });

  //   } catch (error: any) {
  //     console.error('Failed to fetch users:', error.message);
  //   } finally {
  //     if (showLoader) {
  //       setIsLoading(false);
  //     }
  //   }
  // };

  const fetchFilteredUsers = async (showLoader = false) => {
    if (showLoader) {
      setIsLoading(true);
    }

    try {

      const params = new URLSearchParams({
        page: String(currentPage),
        limit: String(itemsPerPage),
        ...(debouncedSearchTerm ? { search: debouncedSearchTerm } : {}),
        ...(selectedRole && selectedRole !== 'all' ? { role: selectedRole } : {}),
        ...(selectedStatus && selectedStatus !== 'all' ? { status: selectedStatus } : {}),
      });

      const response = await fetch(`${import.meta.env.VITE_API_URL}users?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Failed to fetch filtered users');
      }
      const pagination = data?.pagination
      setUsers(data.users);
      setStats({
        total: pagination.totalUsers || 100,
        active: pagination.activeUsers,
        locked: pagination.inActiveUsers,
        requirePasswordReset: 0,
      });
      setPaginationData(data.pagination)

    } catch (error: any) {
      console.error('Failed to fetch users:', error.message);
    } finally {
      if (showLoader) {
        setIsLoading(false);
      }

    }
  };

  useEffect(() => {
    fetchFilteredUsers(true);
  }, [currentPage, itemsPerPage, debouncedSearchTerm, selectedRole, selectedStatus]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (isFirstLoad.current) {
        fetchFilteredUsers(true);
        isFirstLoad.current = false;
      } else {
        fetchFilteredUsers(false);
      }
    });

    return () => clearTimeout(handler);
  }, [debouncedSearchTerm, selectedRole, selectedStatus]);


  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPermissions(permissionSearchTerm, selectedCategory);
    }, 300);

    return () => clearTimeout(handler);
  }, [permissionSearchTerm, selectedCategory]);

  useEffect(() => {
    if (!roleSearchTerm || roleSearchTerm.trim() === '') {
      return;
    }
    const handler = setTimeout(() => {
      fetchRoles(roleSearchTerm);
    }, 300);

    return () => clearTimeout(handler);
  }, [roleSearchTerm]);

  // categories only need fetching once
  useEffect(() => {
    fetchPermissionCategory();
  }, []);

  const isFiltering = searchTerm.trim() !== '' || (selectedStatus && selectedStatus !== 'all');

  const allRoles = users.flatMap(user => user.roles ?? []);
  const uniqueRolesMap = new Map();
  allRoles.forEach(role => {
    if (!uniqueRolesMap.has(role.id)) {
      uniqueRolesMap.set(role.id, role);
    }
  });
  const uniqueRoles = Array.from(uniqueRolesMap.values());

  //API for view user details
  const openViewDialogUser = async (userId: string) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}users/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Error fetching user: ${response.statusText}`);
      }

      const data = await response.json();
      setViewUserData(data);
      setShowViewDialog(true);
    } catch (error) {
      console.error('Failed to fetch user:', error);
    }
  };

  const openViewDialogRole = async (roleId: string) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}roles/${roleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching role: ${response.statusText}`);
      }
      const data = await response.json();
      setViewRoleData(data);
      setShowViewRoleDialog(true);
    } catch (error) {
      console.error("Failed to fetch role:", error);
    }
  };
  // Form state for user creation/editing
  // const [formData, setFormData] = useState({
  //   email: '',
  //   firstName: '',
  //   lastName: '',
  //   role: 'auditor' as UserRole | string,
  //   department: '',
  //   phone: '',
  //   isActive: true,
  //   twoFactorEnabled: false,
  //   requiresPasswordReset: false
  // });
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    roleIds: [] as any[],
    role: '',
    phoneNumber: '',
    isActive: true,
    twoFactorEnabled: false,
    requiresPasswordReset: false,
    password: ''
  });

  // Form state for role creation/editing
  const [roleFormData, setRoleFormData] = useState({
    name: '',
    displayName: '',
    description: '',
    permissionIds: [] as any[],
    color: 'bg-blue-100 text-blue-800',
    isActive: true,
  });

  // Form state for permission creation/editing
  const [permissionFormData, setPermissionFormData] = useState({
    name: '',
    description: '',
    category: '',
    action: ''
  });

  // Get unique departments for filter
  // const departments = useMemo(() => {
  //   const depts = [...new Set(users.map(user => user.department))];
  //   return depts.sort();
  // }, [users]);

  // Update role user counts
  // const rolesWithCounts = useMemo(() => {
  //   return roles?.map(role => ({
  //     ...role,
  //     userCount: users?.filter(user => user.role === role.id).length
  //   }));
  // }, [roles, users]);

  // Filter users based on search and filters
  // const filteredUsers = useMemo(() => {
  //   const filtered = users?.filter(user => {
  //     const matchesSearch =
  //       user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.department.toLowerCase().includes(searchTerm.toLowerCase());

  //     const matchesRole = selectedRole === 'all' || user.role === selectedRole;
  //     const matchesDepartment = selectedDepartment === 'all' || user.department === selectedDepartment;
  //     const matchesStatus =
  //       selectedStatus === 'all' ||
  //       (selectedStatus === 'active' && user.isActive) ||
  //       (selectedStatus === 'inactive' && !user.isActive) ||
  //       (selectedStatus === 'locked' && user.isLocked);

  //     return matchesSearch && matchesRole && matchesDepartment && matchesStatus;
  //   });

  //   return filtered;
  // }, [users, searchTerm, selectedRole, selectedDepartment, selectedStatus]);

  // Filter roles
  // const filteredRoles = useMemo(() => {
  //   return rolesWithCounts.filter(role =>
  //     role.name.toLowerCase().includes(roleSearchTerm.toLowerCase()) ||
  //     role.description.toLowerCase().includes(roleSearchTerm.toLowerCase())
  //   );
  // }, [rolesWithCounts, roleSearchTerm]);

  // const filteredRoles = useMemo(() => {
  //   return roles.filter(role =>
  //     role.name?.toLowerCase().includes(roleSearchTerm.toLowerCase())
  //   );
  // }, [rolesWithCounts, roleSearchTerm]);

  // Filter permissions
  // const filteredPermissions = useMemo(() => {
  //   return permissions.filter(permission => {
  //     const matchesSearch =
  //       permission.name.toLowerCase().includes(permissionSearchTerm.toLowerCase()) ||
  //       permission.description.toLowerCase().includes(permissionSearchTerm.toLowerCase());

  //     const matchesCategory = selectedCategory === 'all' || permission.category === selectedCategory;

  //     return matchesSearch && matchesCategory;
  //   });
  // }, [permissions, permissionSearchTerm, selectedCategory]);

  const filteredPermissions = useMemo(() => {
    const allPermissions: Permission[] = Object.entries(permissions).flatMap(
      ([category, items]) => {
        if (!Array.isArray(items)) return [];

        return items.map((permission) => ({
          ...permission,
          category: category as Permission['category'],
        }));
      }
    );

    return allPermissions;
  }, [permissions]);

  // Get unique permission
  const allPermissionsArray = Object.values(filteredPermissions).flat();
  const uniquePermissionsMap = new Map();
  allPermissionsArray.forEach(permission => {
    if (!uniquePermissionsMap.has(permission.id)) {
      uniquePermissionsMap.set(permission.id, permission);
    }
  });
  const uniquePermissions = Array.from(uniquePermissionsMap.values());
  const uniqueCategories = useMemo(() => {
    const flat = Object.values(filteredPermissions).flat();
    return [...new Set(flat.map(p => p.category?.trim()).filter(Boolean))];
  }, [permissions]);


  // // PAGINATED DATA - Users Table with proper pagination logic
  // const paginatedUsers = useMemo(() => {
  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   return users.slice(startIndex, endIndex);
  // }, [users, currentPage, itemsPerPage]);


  // // Calculate total pages for users
  // const totalPages = useMemo(() => {
  //   return Math.ceil(users.length / itemsPerPage);
  // }, [users.length, itemsPerPage]);

  const paginatedRoles = useMemo(() => {
    const startIndex = (rolesPage - 1) * rolesPerPage;
    return roles.slice(startIndex, startIndex + rolesPerPage);
  }, [roles, rolesPage, rolesPerPage]);


  const paginatedPermissions = useMemo(() => {
    const startIndex = (permissionsPage - 1) * permissionsPerPage;
    return filteredPermissions.slice(startIndex, startIndex + permissionsPerPage);
  }, [filteredPermissions, permissionsPage, permissionsPerPage]);

  // Calculate statistics
  // const stats = useMemo(() => {
  //   const total = users?.length;
  //   const active = users?.filter(u => u.isActive).length;
  //   const locked = users?.filter(u => u.isLocked).length;
  //   const requirePasswordReset = users.filter(u => u.requiresPasswordReset).length;

  //   return { total, active, locked, requirePasswordReset };
  // }, [users]);

  // Reset pagination when filters change
  // React.useEffect(() => {
  //     setCurrentPage(1);
  //     setSelectedUsers([]); // Clear selections when filters change
  // }, [searchTerm, selectedRole, selectedDepartment, selectedStatus]);

  // Handle page size change
  const handleItemsPerPageChange = (newSize: number) => {
    setItemsPerPage(newSize);
    setCurrentPage(1); // Reset to first page when changing page size
    setSelectedUsers([]); // Clear selections when page size changes
  };

  // Handle page change
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    setSelectedUsers([]); // Clear selections when changing pages
  };

  // Role management functions
  //Create Role
  const handleCreateRole = async () => {
    if (!validateRoleForm()) {
      return;
    }
    try {
      const rolePayload = {
        name: roleFormData.name,
        displayName: roleFormData.displayName,
        description: roleFormData.description,
        // permissionIds: selectedPermissions.map(p => p.id)
        permissionIds: roleFormData.permissionIds
      };

      const response = await fetch(`${import.meta.env.VITE_API_URL}roles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(rolePayload)
      });

      const data = await response.json();


      if (!response.ok) {
        throw new Error(data.error || "Failed to create role");
      }

      fetchRoles();
      fetchPermissions();
      fetchFilteredUsers();

      setShowCreateRoleDialog(false);
      // setSelectedPermissions([]);
      resetRoleForm();
      setRoleValidationErrors({ name: "", displayName: "", description: "", permissionIds: "" }); // clear errors
      toast.success("Role created successfully");
    } catch (error: any) {
      console.error("Create role error:", error.message);
      toast.error(error.message || "Something went wrong while creating the role");
    }
  };

  //Edit Role
  const handleEditRole = async () => {
    if (!selectedRoleForEdit) return;
    if (!validateRoleForm()) {
      return;
    }

    try {
      const rolePayload = {
        displayName: roleFormData.displayName,
        description: roleFormData.description,
        isActive: roleFormData.isActive ?? true,
        permissionIds: roleFormData.permissionIds
      };

      const response = await fetch(`${import.meta.env.VITE_API_URL}roles/${selectedRoleForEdit.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(rolePayload)
      });

      const data = await response.json();
      console.log('Edit Role Response:', data);

      if (!response.ok) {
        throw new Error(data.error || 'Failed to update role');
      }

      setRoles(prev =>
        prev.map(role =>
          role.id === selectedRoleForEdit.id
            ? { ...role, ...rolePayload }
            : role
        )
      );
      fetchRoles();
      fetchPermissions();
      setShowEditRoleDialog(false);
      setSelectedRoleForEdit(null);
      resetRoleForm();
      setRoleValidationErrors({ name: "", displayName: "", description: "", permissionIds: "" });
      toast.success('Role updated successfully');
    } catch (error: any) {
      console.error('Edit role error:', error.message);
      toast.error(error.message || 'Something went wrong while updating the role');
    }
  };

  //Delete Role
  const handleDeleteRole = async () => {
    if (!roleToDelete) return;
    // Step 1: Prevent deletion if users are assigned to this role
    const usersWithRole = users.filter(user => user.role === roleToDelete.id);
    if (usersWithRole.length > 0) {
      toast.error(`Cannot delete role: ${usersWithRole.length} user(s) are assigned to this role`);
      return;
    }

    try {
      // Step 2: Call API to delete the role
      const response = await fetch(`${import.meta.env.VITE_API_URL}roles/${roleToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      console.log('Delete Role Response:', data);

      if (!response.ok) {
        throw new Error(data.error || 'Failed to delete role');
      }

      // Step 3: Update frontend state
      setRoles(prev => prev.filter(role => role.id !== roleToDelete.id));
      setShowDeleteRoleDialog(false);
      setRoleToDelete(null);
      toast.success(data.message || 'Role deleted successfully');
    } catch (error: any) {
      console.error('Delete role error:', error.message);
      toast.error(error.message || 'Something went wrong while deleting the role');
    }
  };

  // const handleDuplicateRole = (role: Role) => {
  //   const duplicatedRole: Role = {
  //     ...role,
  //     id: `role-${Date.now()}`,
  //     name: `${role.name} (Copy)`,
  //     isCustom: true,
  //     userCount: 0,
  //     createdAt: new Date(),
  //     updatedAt: new Date()
  //   };

  //   setRoles(prev => [...prev, duplicatedRole]);
  //   toast.success('Role duplicated successfully');
  // };

  // Permission management functions
  // const handleCreatePermission = () => {
  //   const newPermission: Permission = {
  //     id: `${permissionFormData.category}.${permissionFormData.name.toLowerCase().replace(/\s+/g, '_')}`,
  //     ...permissionFormData,
  //     isCustom: true,
  //     createdAt: new Date(),
  //     updatedAt: new Date(),
  //     module:'',
  //     roleCount:0
  //   };
  //   setPermissions(prev => [...prev, newPermission]);
  //   setShowCreatePermissionDialog(false);
  //   resetPermissionForm();
  //   toast.success('Permission created successfully');
  // };

  // const handleCreatePermission = async () => {
  //   const newPermission = {
  //     module: permissionFormData.category,
  //     action: permissionFormData.action,
  //     name: permissionFormData.name,
  //     description: permissionFormData.description
  //   };
  //   try {
  //     const response = await fetch(`${import.meta.env.VITE_API_URL}permissions`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`
  //       },
  //       body: JSON.stringify(newPermission),
  //     });
  //     if (!response.ok) {
  //       throw new Error('Failed to create permission');
  //     }
  //     const createdPermission = await response.json();
  //     setPermissions(prev => Array.isArray(prev) ? [...prev, {
  //       ...createdPermission,
  //       isCustom: true,
  //       createdAt: new Date(),
  //       updatedAt: new Date(),
  //       module: createdPermission.module
  //     }] : [{
  //       ...createdPermission,
  //       isCustom: true,
  //       createdAt: new Date(),
  //       updatedAt: new Date(),
  //       module: createdPermission.module,
  //     }]);
  //     toast.success('Permission created successfully');
  //     fetchPermissions();
  //     setShowCreatePermissionDialog(false);
  //     resetPermissionForm();
  //   } catch (error) {
  //     console.error(error);
  //     toast.error('Failed to create permission');
  //   }
  // };


  // const handleEditPermission = () => {
  //   if (!selectedPermissionForEdit) return;
  //   setPermissions(prev => prev.map(permission =>
  //     permission.id === selectedPermissionForEdit.id
  //       ? { ...permission, ...permissionFormData, updatedAt: new Date() }
  //       : permission
  //   ));
  //   setShowEditPermissionDialog(false);
  //   setSelectedPermissionForEdit(null);
  //   resetPermissionForm();
  //   toast.success('Permission updated successfully');
  // };

  // const handleEditPermission = async () => {
  //   if (!selectedPermissionForEdit) return;

  //   const updatedPermission = {
  //     module: permissionFormData.category,
  //     action: permissionFormData.action,
  //     name: permissionFormData.name,
  //     description: permissionFormData.description
  //   };

  //   try {
  //     const response = await fetch(`${import.meta.env.VITE_API_URL}permissions/${selectedPermissionForEdit.id}`, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}` // make sure token is defined
  //       },
  //       body: JSON.stringify(updatedPermission),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to update permission');
  //     }

  //     const updatedPermissionFromServer = await response.json();

  //     setPermissions(prev => Array.isArray(prev) ? [...prev, {
  //       ...updatedPermissionFromServer,
  //       isCustom: true,
  //       createdAt: new Date(),
  //       updatedAt: new Date(),
  //       module: updatedPermissionFromServer.module
  //     }] : [{
  //       ...updatedPermissionFromServer,
  //       isCustom: true,
  //       createdAt: new Date(),
  //       updatedAt: new Date(),
  //       module: updatedPermissionFromServer.module,
  //     }]);

  //     toast.success('Permission updated successfully');
  //     fetchPermissions();
  //     setShowEditPermissionDialog(false);
  //     setSelectedPermissionForEdit(null);
  //     resetPermissionForm();
  //   } catch (error) {
  //     console.error(error);
  //     toast.error('Failed to update permission');
  //   }
  // };


  // const handleDeletePermission = () => {
  //   if (!permissionToDelete) return;

  //   // Check if permission is in use by any role
  //   const rolesWithPermission = roles.filter(role => role.permissions.includes(permissionToDelete.id));
  //   if (rolesWithPermission.length > 0) {
  //     toast.error(`Cannot delete permission: Used by ${rolesWithPermission.length} roles`);
  //     return;
  //   }

  //   setPermissions(prev => prev.filter(permission => permission.id !== permissionToDelete.id));
  //   setShowDeletePermissionDialog(false);
  //   setPermissionToDelete(null);
  //   toast.success('Permission deleted successfully');
  // };

  // const handleDeletePermission = async () => {
  //   if (!permissionToDelete) return;

  //   const rolesWithPermission = roles.filter(role => role.permissions.includes(permissionToDelete.id));
  //   if (rolesWithPermission.length > 0) {
  //     toast.error(`Cannot delete permission: Used by ${rolesWithPermission.length} roles`);
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${import.meta.env.VITE_API_URL}permissions/${permissionToDelete.id}`, {
  //       method: 'DELETE',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`,
  //       }
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || 'Failed to delete permission');
  //     }
  //     setPermissions(prev =>
  //       Array.isArray(prev) ? prev.filter(permission => permission.id !== permissionToDelete.id) : []
  //     );

  //     setShowDeletePermissionDialog(false);
  //     setPermissionToDelete(null);
  //     fetchPermissions();
  //     toast.success('Permission deleted successfully');
  //   } catch (error: any) {
  //     console.error('Delete error:', error);
  //     toast.error(`Error deleting permission: ${error.message}`);
  //   }
  // };

  // User management functions (existing)
  // const handleCreateUser = () => {
  // const newUser: User = {
  //   id: `user-${Date.now()}`,
  //   ...formData,
  //   createdAt: new Date(),
  //   updatedAt: new Date(),
  //   failedLoginAttempts: 0,
  //   isLocked: false
  // };

  // const handleCreateUser = () => {
  //     const newUser: User = {
  //         id: `user-${Date.now()}`,
  //         ...formData,
  //         createdAt: new Date(),
  //         updatedAt: new Date(),
  //         failedLoginAttempts: 0,
  //         isLocked: false,
  //         total: 0
  //     };

  //     setUsers(prev => [...prev, newUser]);
  //     setShowCreateDialog(false);
  //     resetForm();
  //     toast.success('User created successfully');
  // };

  // const handleCreateUser = async () => {
  //         try {
  //             const response = await fetch("https://mas-medical-dev.openturf.dev/api/v1/users", {
  //                 method: "POST",
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                     Authorization: `Bearer ${token}`
  //                 },
  //                 body: JSON.stringify(formData)
  //             });

  //             if (!response.ok) {
  //                 const errorData = await response.json();
  //                 throw new Error(errorData.message || "Failed to create user");
  //             }

  //             toast.success("User created successfully");
  //             await fetchUsers();
  //             setShowCreateDialog(false);
  //             resetForm();
  //         } catch (error: any) {
  //             console.error("Error creating user:", error);
  //             toast.error(error.message || "An error occurred");
  //         }
  // };

  // const handleCreateUser = async () => {
  //   try {
  //     const payload = {
  //       email: formData.email,
  //       firstName: formData.firstName,
  //       lastName: formData.lastName,
  //       phoneNumber: formData.phoneNumber,
  //       password: formData.password,
  //       roleIds: formData.roleIds,
  //       // mustChangePassword: true
  //     };

  //     const response = await fetch(`${import.meta.env.VITE_API_URL}users`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`
  //       },
  //       body: JSON.stringify(payload)
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || "Failed to create user");
  //     }

  //     toast.success("User created successfully");
  //     await fetchUsers();
  //     fetchRoles();
  //     setShowCreateDialog(false);
  //     resetForm();
  //   } catch (error: any) {
  //     console.error("Error creating user:", error);
  //     toast.error(error.message || "An error occurred");
  //   }
  // };

  // const handleFieldBlur = (field: string) => {
  //   const value = formData[field];
  //   let error = '';

  //   switch (field) {
  //     case 'firstName':
  //       if (!value?.trim()) {
  //         error = 'First name is required';
  //       } else if (value.length < 2 || value.length > 50) {
  //         error = 'First name must be between 2 and 50 characters';
  //       }
  //       break;

  //     case 'lastName':
  //       if (value && (value.length < 2 || value.length > 50)) {
  //         error = 'Last name must be between 2 and 50 characters';
  //       }
  //       break;

  //     case 'email':
  //       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //       if (!value?.trim()) {
  //         error = 'Email is required';
  //       } else if (!emailRegex.test(value)) {
  //         error = 'Please enter a valid email address';
  //       }
  //       break;

  //     case 'phoneNumber':
  //       if (value) {
  //         const phoneRegex = /^\d{10}$/;
  //         if (!phoneRegex.test(value)) {
  //           error = 'Please enter the valid phone number';
  //         }
  //       }
  //       break;

  //     case 'password':
  //       if (!value?.trim()) {
  //         error = 'Password is required';
  //       } else if (value.length < 8) {
  //         error = 'Password must be at least 8 characters';
  //       } else {
  //         const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/;
  //         if (!passwordRegex.test(value)) {
  //           error = 'Password must contain uppercase, lowercase, number and special character';
  //         }
  //       }
  //       break;

  //     case 'roleIds':
  //       if (!value || value.length === 0 || !value[0]) {
  //         error = 'Please select the role';
  //       }
  //       break;

  //     default:
  //       break;
  //   }

  //   setValidationErrors(prev => ({ ...prev, [field]: error }));
  // };
  const handleFieldBlur = (field: string) => {
    const value = formData[field];
    let error = '';

    switch (field) {
      case 'firstName':
        if (!value?.trim()) {
          error = 'First name is required';
        } else if (value.length < 2 || value.length > 50) {
          error = 'First name must be between 2 and 50 characters';
        } else if (!/^[A-Za-z][A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value)) {
          error = 'Must starts with alpha characters';
        } else if (/^\d+$/.test(value)) {
          error = 'First name cannot be only numbers';
        } else if (/^[^a-zA-Z0-9]+$/.test(value)) {
          error = 'First name cannot be only special characters';
        } else if (/\s/.test(value)) {
          error = 'First name cannot contain spaces';
        }
        break;

      case 'lastName':
        if (!value?.trim()) {
          error = 'Last name is required';
        } else if (value.length < 2 || value.length > 50) {
          error = 'Last name must be between 2 and 50 characters';
        } else if (!/^[A-Za-z][A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(value)) {
          error = 'Must starts with alpha characters';
        } else if (/^\d+$/.test(value)) {
          error = 'Last name cannot be only numbers';
        } else if (/^[^a-zA-Z0-9]+$/.test(value)) {
          error = 'Last name cannot be only special characters';
        } else if (/\s/.test(value)) {
          error = 'Last name cannot contain spaces';
        }

        break;

      case 'email':
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!value?.trim()) {
          error = 'Email is required';
        } else if (!emailRegex.test(value)) {
          error = 'Please enter a valid email address';
        } else if (isDuplicateEmail(value)) {
          error = 'Email already exists';
        }
        break;

      case 'phoneNumber':
        if (value?.trim()) {
          const phoneRegex = /^(?:\+1)?[2-9][0-9]{9}$/;
          if (!phoneRegex.test(value)) {
            error = 'Enter a valid phone number';
          }
        }
        break;



      case 'password':
        if (!value?.trim()) {
          error = 'Password is required';
        } else if (value.length < 8 || value.length > 32) {
          error = 'Password must be between 8 and 32 characters';
        } else {
          const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,32}$/;
          if (!passwordRegex.test(value)) {
            error =
              'Password must include uppercase, lowercase, number, and special character';
          }
        }
        break;

      case 'roleIds':
        if (!value || value.length === 0 || !value[0]) {
          error = 'Please select the role';
        }
        break;

      default:
        break;
    }

    setValidationErrors((prev) => ({ ...prev, [field]: error }));
  };


  const handleRoleFieldBlur = (field: string) => {
    const value = roleFormData[field];
    let error = "";

    switch (field) {
      case "name": {
        const name = value?.trim() || "";
        if (!name) {
          error = "Role name is required";
        } else if (name.length < 2 || name.length > 50) {
          error = "Role name must be between 2 and 50 characters";
        } else if (/^\d+$/.test(name)) {
          error = "Role name cannot be only numbers";
        } else if (/^[^a-zA-Z0-9]+$/.test(name)) {
          error = "Role name cannot be only special characters";
        } else if (!/^[A-Za-z]/.test(name)) {
          error = "Role name must start with a letter";
        }
        break;
      }

      case "displayName": {
        const displayName = value?.trim() || "";
        if (!displayName) {
          error = "Display name is required";
        } else if (displayName.length < 2 || displayName.length > 50) {
          error = "Display name must be between 2 and 50 characters";
        } else if (/^\d+$/.test(displayName)) {
          error = "Display name cannot be only numbers";
        } else if (/^[^a-zA-Z0-9]+$/.test(displayName)) {
          error = "Display name cannot be only special characters";
        } else if (!/^[A-Za-z]/.test(displayName)) {
          error = "Display name must start with a letter";
        }
        break;
      }

      case "description": {
        const description = value?.trim() || "";
        if (!description) {
          error = "Description is required";
        } else if (description.length < 5 || description.length > 250) {
          error = "Description must be between 5 and 250 characters";
        } else if (/^\d+$/.test(description)) {
          error = "Description cannot be only numbers";
        } else if (/^[^a-zA-Z0-9]+$/.test(description)) {
          error = "Description cannot be only special characters";
        }
        break;
      }

      case "permissionIds":
        if (!value || value.length === 0) {
          error = "At least one permission is required";
        }
        break;

      default:
        break;
    }

    setRoleValidationErrors(prev => ({ ...prev, [field]: error }));
  };







  const handleCreateUser = async () => {
    if (!validateForm()) {
      toast.error("Fill all the fields");
      return;
    }
    try {
      const payload = {
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
        password: formData.password,
        roleIds: formData.roleIds,
      };
      const response = await fetch(`${import.meta.env.VITE_API_URL}users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const responseBody = await response.json();
      if (!response.ok) {
        const errorMessage = responseBody?.error;
        throw new Error(errorMessage);
      }
      toast.success("User created successfully");
      fetchRoles();
      await fetchFilteredUsers();
      setShowCreateDialog(false);
      resetForm();
    } catch (error: any) {
      console.error("Error creating user:", error);
      toast.error(error.message || "An error occurred");
    }
  };

  // if (!response.ok) {
  //   const errorData = await response.json();


  //   // If there are field-level errors (common in validation APIs)
  //   if (errorData.errors && typeof errorData.errors === 'object') {
  //     const serverErrors: Record<string, string> = {};
  //     Object.keys(errorData.errors).forEach(key => {
  //       serverErrors[key] = Array.isArray(errorData.errors[key])
  //         ? errorData.errors[key][0]
  //         : errorData.errors[key];
  //     });
  //     setValidationErrors(prev => ({ ...prev, ...serverErrors }));

  //     // Show the first error message from the server response
  //     const firstErrorMessage = Object.values(serverErrors)[0];
  //     toast.error(firstErrorMessage || "Failed to create user");
  //   } else {
  //     // Generic fallback to show message from response
  //     toast.error(errorData.message || "Failed to create user");
  //   }
  //   return;
  // }

  //   toast.success("User created successfully");
  //   await fetchUsers();
  //   fetchRoles();
  //   setShowCreateDialog(false);
  //   resetForm();
  // } catch (error: any) {
  //     console.error("Error creating user:", error);
  //     toast.error(error.message || "An error occurred");
  //   }
  // };



  // const handleEditUser = () => {
  //   if (!selectedUser) return;

  //   setUsers(prev => prev.map(user =>
  //     user.id === selectedUser.id
  //       ? { ...user, ...formData, updatedAt: new Date() }
  //       : user
  //   ));

  //   setShowEditDialog(false);
  //   setSelectedUser(null);
  //   resetForm();
  //   toast.success('User updated successfully');
  // };

  // const handleEditUser = async () => {

  //   if (!selectedUser) return;
  //   try {
  //     const payload = {
  //       firstName: formData.firstName,
  //       lastName: formData.lastName,
  //       phoneNumber: formData.phoneNumber,
  //       roleIds: [formData.role],
  //       // isActive: formData.isActive
  //     };
  //     const response = await fetch(`${import.meta.env.VITE_API_URL}users/${selectedUser.id}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`
  //       },
  //       body: JSON.stringify(payload)
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || "Failed to update user");
  //     }

  //     toast.success("User updated successfully");
  //     await fetchUsers();
  //     fetchRoles();
  //     setShowEditDialog(false);
  //     setSelectedUser(null);
  //     resetForm();

  //   } catch (error: any) {
  //     console.error("Error updating user:", error);
  //     toast.error(error.message || "An error occurred");
  //   }
  // };

  const handleEditUser = async () => {
    if (!selectedUser) return;

    const errors = {
      firstName: '',
      lastName: '',
      phoneNumber: ''
    };

    if (!formData.firstName.trim()) {
      errors.firstName = 'First name is required';
    } else if (formData.firstName.length < 2 || formData.firstName.length > 50) {
      errors.firstName = 'First name must be between 2 and 50 characters';
    }

    if (!formData.lastName.trim()) {
      errors.firstName = 'First name is required';
    } else if (formData.lastName.length < 2 || formData.lastName.length > 50) {
      errors.lastName = 'Last name must be between 2 and 50 characters';
    }

    if (formData.phoneNumber) {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(formData.phoneNumber)) {
        errors.phoneNumber = 'Phone number must be valid';
      }
    }

    setValidationErrors((prev) => ({
      ...prev,
      ...errors
    }));

    if (Object.values(errors).some((error) => error)) {
      toast.error;
      return;
    }

    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
        roleIds: [formData.role]
      };

      const response = await fetch(`${import.meta.env.VITE_API_URL}users/${selectedUser.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update user");
      }

      toast.success("User updated successfully");
      fetchRoles();
      await fetchFilteredUsers();
      setShowEditDialog(false);
      setSelectedUser(null);
      resetForm();

    } catch (error: any) {
      console.error("Error updating user:", error);
      toast.error(error.message || "An error occurred");
    }
  };


  const handleDeleteUser = () => {
    if (!userToDelete) return;

    setUsers(prev => prev.filter(user => user.id !== userToDelete.id));
    setShowDeleteDialog(false);
    setUserToDelete(null);
    toast.success('User deleted successfully');
  };

  // const handleToggleUserStatus = (userId: string) => {
  //     setUsers(prev => prev.map(user =>
  //         user.id === userId
  //             ? { ...user, isActive: !user.isActive, updatedAt: new Date() }
  //             : user
  //     ));
  //     toast.success('User status updated');
  // };

  const handleToggleUserStatus = async (userId: string, isActive: boolean) => {
    try {
      const url = isActive
        ? `${import.meta.env.VITE_API_URL}users/${userId}/deactivate`
        : `${import.meta.env.VITE_API_URL}users/${userId}/activate`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update user status");
      }
      toast.success(`User ${isActive ? "deactivated" : "activated"} successfully`);
      await fetchFilteredUsers();
    } catch (error: any) {
      console.error("Error toggling user status:", error);
      toast.error(error.message || "An error occurred");
    }
  };

  const handleUnlockUser = (userId: string) => {
    setUsers(prev => prev.map(user =>
      user.id === userId
        ? { ...user, isLocked: false, failedLoginAttempts: 0, updatedAt: new Date() }
        : user
    ));
    toast.success('User unlocked successfully');
  };

  const handleResetPassword = (userId: string) => {
    setUsers(prev => prev.map(user =>
      user.id === userId
        ? { ...user, requiresPasswordReset: true, updatedAt: new Date() }
        : user
    ));
    toast.success('Password reset email sent');
  };

  // Form reset functions
  // const resetForm = () => {
  //     setFormData({
  //         email: '',
  //         firstName: '',
  //         lastName: '',
  //         roleIds: [],
  //         role:'',
  //         // department: '',
  //         phoneNumber: '',
  //         isActive: true,
  //         twoFactorEnabled: false,
  //         requiresPasswordReset: false
  //     });
  // };

  const resetForm = () => {
    setFormData({
      email: '',
      firstName: '',
      lastName: '',
      roleIds: [],
      role: '',
      phoneNumber: '',
      isActive: true,
      twoFactorEnabled: false,
      requiresPasswordReset: false,
      password: ''
    });
  };


  const resetRoleForm = () => {
    setRoleFormData({
      name: '',
      displayName: '',
      description: '',
      permissionIds: [],
      color: 'bg-blue-100 text-blue-800',
      isActive: true,

    });
  };

  const resetPermissionForm = () => {
    setPermissionFormData({
      name: '',
      description: '',
      category: '',
      action: ''
    });
  };

  // Dialog opening functions
  // const openEditDialog = (user: User) => {
  //   setSelectedUser(user);
  //   setFormData({
  //     email: user.email,
  //     firstName: user.firstName,
  //     lastName: user.lastName,
  //     role: user.role,
  //     department: user.department,
  //     phone: user.phone || '',
  //     isActive: user.isActive,
  //     twoFactorEnabled: user.twoFactorEnabled,
  //     requiresPasswordReset: user.requiresPasswordReset
  //   });
  //   setShowEditDialog(true);
  // };
  const openEditDialog = (user: any) => {
    setSelectedUser(user);
    if(roles.length === 0) {
      fetchRoles();
    }
    setFormData({
      email: user.email ?? '',
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      phoneNumber: user.phoneNumber ?? '',
      role: user.roles?.[0]?.id ?? '',
      roleIds: user.roles?.map((r: any) => r.id) ?? [],
      isActive: user.isActive ?? true,
      twoFactorEnabled: user.twoFactorEnabled ?? false,
      requiresPasswordReset: user.requiresPasswordReset ?? false,
      password: ''
    });
    setShowEditDialog(true);
  };


  const openEditRoleDialog = (role: Role) => {
    setSelectedRoleForEdit(role);
    setRoleFormData({
      name: role.name,
      displayName: role.displayName,
      description: role.description,
      permissionIds: role.permissions.map(p => p["id"]),
      color: role.color,
      isActive: true,
    });
    setShowEditRoleDialog(true);
  };


  const openEditPermissionDialog = (permission: Permission) => {
    setSelectedPermissionForEdit(permission);
    setPermissionFormData({
      name: permission.name,
      description: permission.description,
      category: permission.category,
      action: permission.action
    });
    setShowEditPermissionDialog(true);
  };

  // Utility functions
  const getRoleInfo = (roleId: UserRole | string) => {
    return roles.find(role => role.id === roleId) || roles[0];
  };

  const formatLastLogin = (date?: Date) => {
    if (!date) return 'Never';
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
    return `${Math.floor(days / 30)} months ago`;
  };

  const roleColorOptions = [
    'bg-red-100 text-red-800',
    'bg-purple-100 text-purple-800',
    'bg-blue-100 text-blue-800',
    'bg-green-100 text-green-800',
    'bg-yellow-100 text-yellow-800',
    'bg-indigo-100 text-indigo-800',
    'bg-pink-100 text-pink-800',
    'bg-gray-100 text-gray-800'
  ];

  // Reset filters function
  const resetFilters = () => {
    setSearchTerm('');
    setSelectedRole('all');
    // setSelectedDepartment('all');
    setSelectedStatus('all');
    setCurrentPage(1);
    setSelectedUsers([]);
    setRoleSearchTerm('');
    setRolesPage(1);
    setPermissionSearchTerm('');
    setSelectedCategory('all');
    setPermissionsPage(1);
  };

  const permissionColumns = ['Permission', 'Description', 'Category', 'Used in Roles', 'Created', 'Action'];
  const roleColumns = ['Role', 'Description', 'Users', 'Permissions', 'Users', 'Created', 'Actions', 'Actions'];
  const userColumns = ['User', 'Role', 'Status', 'Last Active', 'Created', 'Actions'];

  const userManagementMenu = sideBarItems.find((item: any) => item.name === "User Management");
  const hasActivatePermission = userManagementMenu?.userPermissions?.includes("users:activate");
  const hasDeactivatePermission = userManagementMenu?.userPermissions?.includes("users:deactivate");
  const handlePermissioClick = (user: any) => {
    if (user?.isActive) {
      if (hasDeactivatePermission) {
        handleToggleUserStatus(user.id, user.isActive);
      } else {
        toast.error("You need 'users:deactive' permission to deactivate this user Or contact the administrator to activate the user");
      }
    }
    else {
      if (hasActivatePermission) {
        handleToggleUserStatus(user.id, user.isActive);
      } else {
        toast.error("You need 'users:active' permission to activate this user Or contact the administrator to activate the user");
      }
    }
  };

  return (
    <Layout>
      <div className="p-8" style={{ fontSize: '11.2px' }}>
        {/* Breadcrumb Navigation */}
        <div className="mb-6">
          <Breadcrumb>
            <BreadcrumbList>
              {/* <BreadcrumbItem>
                <BreadcrumbLink href="#" onClick={() => setCurrentView('dashboard')} className="flex items-center gap-2">
                  <Home className="w-3 h-3" />
                  Dashboard
                </BreadcrumbLink>
              </BreadcrumbItem> */}
              {/* <BreadcrumbSeparator /> */}
              <BreadcrumbItem>
                <BreadcrumbPage className="flex items-center gap-2 font-inter font-medium text-base leading-[100%] tracking-[0] text-[#2C3E5D]" style={{ fontSize: '11.2px' }}>
                  <Users className="w-5 h-5 text-[#2C3E5D]" />
                  User Management
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-inter font-semibold text-2xl leading-[100%] tracking-[0] text-[#172B4D] mb-2">
              User Management
            </h1>
            <p className="font-inter font-normal text-[16px] leading-[20px] tracking-[0] text-[#758195]">
              Manage user accounts, roles, and permissions
            </p>
          </div>

          <div className="flex items-center gap-3">
            {/* <Button variant="outline" size="sm" className="font-inter font-semibold text-sm leading-[20px] tracking-[0] text-[#2C3E5D]">
              <Upload className="w-4 h-4 mr-2 text-[#2C3E5D]" />
              Export
            </Button>
            <Button variant="outline" size="sm" className="font-inter font-semibold text-sm leading-[20px] tracking-[0] text-[#2C3E5D]">
              <Download className="w-4 h-4 mr-2 text-[#2C3E5D]" />
              Import
            </Button> */}
            {(userManagementMenu?.userPermissions?.includes("users:create")) && (
              // <Dialog open={showCreateDialog} onOpenChange={setShowCreateDialog}>
              <Button
                onClick={() => {
                  if (
                    userManagementMenu?.userPermissions?.includes("users:create")
                  ) {
                    resetFilters();
                    resetForm();
                    if (roles.length === 0) {
                      fetchRoles();
                    }
                    setShowCreateDialog(true);
                    clearValidationErrors();
                  } else {
                    toast.error("You need 'roles:view' permissions to access this resource.");
                  }
                }}
                className="font-inter font-semibold text-sm leading-[20px] tracking-[0] text-white"
              >
                <Plus className="w-4 h-4 mr-2 text-[#FFFFFF]" />
                Add User
              </Button>
              //</Dialog>
            )}
          </div>
        </div>

        <Tabs defaultValue="users" className="space-y-6">
          {/* <TabsList className="w-full h-[36px] p-[4px] rounded-[100px] bg-[#F7F8F9] opacity-100 flex">
            <TabsTrigger value="users" className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">Users</TabsTrigger>
            <TabsTrigger value="roles" className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">Roles</TabsTrigger>
            <TabsTrigger value="permissions" className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">Permissions</TabsTrigger>
          </TabsList> */}
          <TabsList className="w-full h-[36px] p-[4px] rounded-[100px] bg-[#F7F8F9] opacity-100 flex">
            <TabsTrigger
              value="users"
              onClick={resetFilters}
              className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
            >
              Users
            </TabsTrigger>
            <TabsTrigger
              value="roles"
              onClick={() => {
                resetFilters();
                fetchRoles();
              }}
              className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
            >
              Roles
            </TabsTrigger>
            <TabsTrigger
              value="permissions"
              onClick={() => {
                resetFilters();
              }}
              className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
            >
              Permissions
            </TabsTrigger>
          </TabsList>


          <TabsContent value="users" className="space-y-6">
            {(!userManagementMenu?.userPermissions?.includes("users:view")) ? (
              <div className="p-6">
                <Alert>
                  <AlertTriangle className="w-4 h-4" />
                  <AlertDescription>
                    <div>You don't have permission to access <b>User Management.</b></div>
                  </AlertDescription>
                </Alert>
              </div>
            ) : (
              <>
                {/* Statistics Cards */}
                <Card>
                  <CardContent className='p-4 [&:last-child]:pb-4'>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 justify-center place-items-center">
                      <Card className='w-80'>
                        <CardContent className="p-6">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-[50px] bg-blue-100 opacity-100 p-2 flex items-center justify-center">

                              {/* <div> */}
                              <Users className="w-8 h-8 text-blue-600" />
                            </div>

                            <div>

                              <p className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D] mb-2"
                              >
                                {/* {stats.total} */}
                                {stats?.total ?? '—'}
                              </p>
                              <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ">Total Users</p>

                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      <Card className='w-80'>
                        <CardContent className="p-6">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-[50px] bg-green-100 opacity-100 p-2 flex items-center justify-center mb-1">
                              {/* <div> */}
                              <UserCheck className="w-8 h-8 text-green-600" />
                            </div>
                            <div>

                              <p className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D] mb-2">
                                {/* {stats.active} */}
                                {stats?.active ?? '—'}
                              </p>
                              <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]  mb-2">Active Users</p>

                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      <Card className='w-80'>
                        <CardContent className="p-6">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-[50px] bg-red-100 opacity-100 p-2 flex items-center justify-center">
                              {/* <div> */}
                              <Lock className="w-8 h-8 text-red-600" />
                            </div>
                            <div>

                              <p className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]  mb-2">
                                {/* {stats.locked} */}
                                {stats?.locked ?? '—'}
                              </p>
                              <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]">Locked Accounts</p>

                            </div>
                          </div>
                        </CardContent>
                      </Card>


                      {/* <Card>
                    <CardContent className="p-6">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-[50px] bg-yellow-100 opacity-100 p-2 flex items-center justify-center">
                          <AlertTriangle className="w-5 h-5 text-yellow-600" />
                        </div>
                        <div>
                          <p className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]  mb-2">
                            
                            {stats?.requirePasswordReset ?? '—'}
                          </p>
                          <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]">Password Reset</p>

                        </div>
                      </div>
                    </CardContent>
                  </Card> */}
                    </div>
                  </CardContent>
                </Card>

                {/* Filters */}
                <Card>
                  <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 ">
                      <div className="relative col-span-2">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <Input
                          placeholder="Search users..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="pl-10 font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2] placeholder:text-[#8590A2]"
                        />
                      </div>

                      <Select value={selectedRole} onValueChange={setSelectedRole}>
                        <SelectTrigger className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">
                          <SelectValue placeholder="All Roles" />
                        </SelectTrigger>
                        <SelectContent className="max-h-80 w-full overflow-y-auto rounded-lg shadow-lg border border-gray-200 bg-white font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2] ">
                          <SelectItem value="all">All Roles</SelectItem>
                          {/* {roles.map(role => (
                        <SelectItem key={role.id} value={role.id}>
                          {role.name}
                        </SelectItem>
                      ))} */}
                          {(isFiltering ? uniqueRoles : roles)?.map(role => (
                            <SelectItem key={role.id} value={role.name}>
                              {role.name}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>

                      {/* <Select value={selectedDepartment} onValueChange={setSelectedDepartment}>
                    <SelectTrigger className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">
                      <SelectValue placeholder="All Departments" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all" className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">All Departments</SelectItem>
                      {(departments ?? []).map(dept => (
                        <SelectItem key={dept} value={dept} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">
                          {dept ?? 'Unamed'}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select> */}

                      <Select value={selectedStatus} onValueChange={setSelectedStatus}>
                        <SelectTrigger className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]" >
                          <SelectValue placeholder="All Status" />
                        </SelectTrigger>
                        <SelectContent className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">
                          <SelectItem value="all">All Status</SelectItem>
                          <SelectItem value="active">Active</SelectItem>
                          <SelectItem value="inactive">Inactive</SelectItem>
                          {/* <SelectItem value="locked">Locked</SelectItem> */}
                        </SelectContent>
                      </Select>

                      <Button
                        variant="outline"
                        onClick={resetFilters}
                        className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                      >
                        <RefreshCw className="w-4 h-4 mr-2 text-[#2C3E5D]" />
                        Reset
                      </Button>
                    </div>
                  </CardContent>
                </Card>

                {/* Users Table with Pagination */}
                {isLoading ? (
                  <LoadingTable
                    title="Users"
                    columns={userColumns}
                    rows={6}
                    showPagination={true}
                  />
                ) : (
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center justify-between">
                        <span className="font-inter font-medium text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]" >
                          Users ({users.length})
                        </span>
                        {selectedUsers?.length > 0 && (
                          <div className="flex items-center gap-2">
                            <span className="text-sm text-gray-600">
                              {selectedUsers?.length} selected
                            </span>
                            <Button variant="outline" size="sm">
                              Bulk Actions
                            </Button>
                          </div>
                        )}
                      </CardTitle>
                      {/* <CardDescription>
                  Page {currentPage} of {totalPages} ({Math.min((currentPage - 1) * itemsPerPage + 1, users.length)}-{Math.min(currentPage * itemsPerPage, users.length)} of {users.length} users)
                </CardDescription> */}
                    </CardHeader>
                    <CardContent>
                      <div className="overflow-x-auto">
                        <Table>
                          <TableHeader>
                            <TableRow>
                              {/* <TableHead className="w-12">
                            <Checkbox
                              checked={selectedUsers?.length === paginatedUsers?.length && paginatedUsers?.length > 0}
                              onCheckedChange={(checked) => {
                                if (checked) {
                                  setSelectedUsers(paginatedUsers?.map(u => u.id));
                                } else {
                                  setSelectedUsers([]);
                                }
                              }}
                            />
                          </TableHead> */}
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">User</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Role</TableHead>
                              {/* <TableHead className="font-inter font-semibold text-[12px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Department</TableHead> */}
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Status</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Last Login</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Actions</TableHead>
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {users?.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} className="text-center py-8">
                                  <div className="flex flex-col items-center gap-2">
                                    {/* <Users className="w-8 h-8 text-gray-400" /> */}
                                    <p className="text-gray-500 text-sm">
                                      No Users Found
                                    </p>
                                    {/* <Button variant="outline" size="sm" onClick={resetFilters}>
                                Clear Filters
                              </Button> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ) : (
                              (users ?? []).map((user: any) => {
                                if (!user) return null;
                                // const roleInfo = user?.roles?.[0]?.id;
                                // paginatedUsers.map((user) => {
                                //   const roleInfo = getRoleInfo(user?.role);
                                return (
                                  <TableRow key={user?.id}>
                                    {/* <TableCell>
                                  <Checkbox
                                    checked={selectedUsers.includes(user?.id)}
                                    onCheckedChange={(checked) => {
                                      if (checked) {
                                        setSelectedUsers(prev => [...prev, user?.id]);
                                      } else {
                                        setSelectedUsers(prev => prev.filter(id => id !== user?.id));
                                      }
                                    }}
                                  />
                                </TableCell> */}
                                    <TableCell>
                                      <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                          {/* <span className="text-blue-600 text-xs font-medium">
                                      {user?.firstName.charAt(0)}{user?.lastName.charAt(0)}
                                    </span> */}
                                          <span className="text-blue-600 font-inter font-medium text-[14px] leading-[20px] tracking-normal">
                                            {(user?.firstName?.[0] ?? '') + (user?.lastName?.[0] ?? '')}
                                          </span>
                                        </div>
                                        <div>
                                          {/* <p className="font-medium text-gray-900" style={{ fontSize: '11.2px' }}>
                                      {user?.firstName} {user?.lastName}
                                    </p>
                                    <p className="text-gray-500" style={{ fontSize: '10px' }}>
                                      {user?.email}
                                    </p> */}
                                          <p className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                            {user?.firstName ?? '—'} {user?.lastName}
                                          </p>
                                          <p className=" mt-1 font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                            {user?.email ?? '—'}
                                          </p>
                                        </div>
                                      </div>
                                    </TableCell>
                                    {/* <TableCell>
                                
                                <Badge className={roleInfo.color}>
                                  {roleInfo.name}
                                </Badge>
                              </TableCell> */}
                                    {/* <TableCell>
                                {(user?.roles ?? []).length > 0 ? (
                                  user.roles.map((role: any) => (
                                    <Badge key={role.id} className={role.color}>
                                      {role.displayName || role.name}
                                    </Badge>
                                  ))
                                ) : (
                                  <Badge className="bg-gray-100 text-gray-500">No Role</Badge>
                                )}
                              </TableCell> */}
                                    <TableCell>
                                      {(user?.roles ?? []).length > 0 ? (
                                        user.roles.map((role: any) => (
                                          <Badge
                                            key={role.id}
                                            className={`cursor-pointer ${role.color} font-inter font-normal text-[14px] leading-[100%] tracking-normal`}
                                            onClick={() => openViewDialogRole(role.id)}
                                          >
                                            {role.displayName || role.name}
                                          </Badge>
                                        ))
                                      ) : (
                                        <Badge className="bg-gray-100 text-gray-500 font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">No Role</Badge>
                                      )}
                                    </TableCell>


                                    {/* <TableCell> */}
                                    {/* <span className="text-gray-900" style={{ fontSize: '11.2px' }}>
                                  {user.department}
                                </span> */}
                                    {/* <span className="text-gray-900" style={{ fontSize: '11.2px' }}>
                                  {user?.department ?? '—'}
                                </span>
                              </TableCell> */}
                                    <TableCell>
                                      <div className="flex items-center gap-2">
                                        {user?.isLocked ? (
                                          <Badge className="bg-red-100 text-red-800 font-inter font-normal text-[14px] leading-[100%] tracking-normal">
                                            <Lock className="w-3 h-3 mr-1" />
                                            Locked
                                          </Badge>
                                        ) : user?.isActive ? (
                                          <Badge className="bg-green-100 text-green-800 font-inter font-normal text-[14px] leading-[100%] tracking-normal">
                                            <CheckCircle className="w-3 h-3 mr-1" />
                                            Active
                                          </Badge>
                                        ) : (
                                          <Badge className="bg-gray-100 text-gray-800 font-inter font-normal text-[14px] leading-[100%] tracking-normal">
                                            <UserX className="w-3 h-3 mr-1" />
                                            Inactive
                                          </Badge>
                                        )}
                                        {user?.requiresPasswordReset && (
                                          <Badge className="bg-yellow-100 text-yellow-800 font-inter font-normal text-[14px] leading-[100%] tracking-normal">
                                            Reset Required
                                          </Badge>
                                        )}
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      {/* <span className="text-gray-600" style={{ fontSize: '11.2px' }}>
                                  {formatLastLogin(user.lastLogin)}
                                </span> */}
                                      <span className=" font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                        {user?.lastLogin
                                          ? new Date(user.lastLogin).toLocaleString()
                                          : 'N/A'}
                                      </span>
                                    </TableCell>
                                    <TableCell>
                                      <DropdownMenu>
                                        <DropdownMenuTrigger asChild>
                                          <Button variant="ghost" size="sm">
                                            <MoreHorizontal className="w-4 h-4  text-[#2C3E5D]" />
                                          </Button>
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent align="end">
                                          <DropdownMenuItem onClick={() => openViewDialogUser(user.id)} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                            <Eye className="w-4 h-4 mr-2 text-[#758195] " />
                                            View User
                                          </DropdownMenuItem>
                                          {(userManagementMenu?.userPermissions?.includes("users:edit")) && (
                                            <DropdownMenuItem onClick={() => {

                                              openEditDialog(user);
                                              clearValidationErrors();
                                            }
                                            } className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                              <Edit className="w-4 h-4 mr-2 text-[#758195]" />
                                              Edit User
                                            </DropdownMenuItem>
                                          )}
                                          {/* {(userManagementMenu?.userPermissions?.includes("users:deactivate")) && (
                                            <DropdownMenuItem onClick={() => handleToggleUserStatus(user.id, user.isActive)} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                              {user?.isActive ? (
                                                <>
                                                  <UserX className="w-4 h-4 mr-2 text-[#758195]" />
                                                  Deactivate
                                                </>
                                              ) : (
                                                <>
                                                  <UserCheck className="w-4 h-4 mr-2" />
                                                  Activate
                                                </>
                                              )}
                                            </DropdownMenuItem>
                                          )} */}
                                          {(user?.isActive ? hasDeactivatePermission : hasActivatePermission) && (
                                            <DropdownMenuItem
                                              onClick={() => {
                                                handlePermissioClick(user);
                                              }}
                                              className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                                            >
                                              {user?.isActive ? (
                                                <>
                                                  <UserX className="w-4 h-4 mr-2 text-[#758195]" />
                                                  Deactivate
                                                </>
                                              ) : (
                                                <>
                                                  <UserCheck className="w-4 h-4 mr-2" />
                                                  Activate
                                                </>
                                              )}
                                            </DropdownMenuItem>
                                          )}




                                          {/* {user?.isLocked && (
                                                                            <DropdownMenuItem onClick={() => handleUnlockUser(user?.id)}>
                                                                                <Unlock className="w-4 h-4 mr-2" />
                                                                                Unlock Account
                                                                            </DropdownMenuItem>
                                                                        )}
                                    <DropdownMenuItem onClick={() => handleResetPassword(user?.id)} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                                                            <RefreshCw className="w-4 h-4 mr-2 text-[#758195]" />
                                                                            Reset Password
                                                                        </DropdownMenuItem>
                                                                        <DropdownMenuSeparator />
                                                                        <DropdownMenuItem
                                                                            onClick={() => {
                                                                                setUserToDelete(user);
                                                                                setShowDeleteDialog(true);
                                                                            }}
                                                                            className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#E5102E]"
                                                                        >
                                                                            <Trash2 className="w-4 h-4 mr-2 text-[#758195]" />
                                                                            Delete User
                                                                        </DropdownMenuItem> */}
                                        </DropdownMenuContent>
                                      </DropdownMenu>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            )}
                          </TableBody>
                        </Table>
                      </div>

                      {/* Users Pagination */}
                      {users.length > 0 && (
                        <div className="mt-6">
                          <PaginationCustom
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onItemsPerPageChange={() => setCurrentPage(1)}
                          />
                        </div>
                      )}
                    </CardContent>
                  </Card>
                )}
              </>
            )}
          </TabsContent>

          <TabsContent value="roles" className="space-y-6">
            {(!userManagementMenu?.userPermissions?.includes("roles:view")) ? (
              <div className="p-6">
                <Alert>
                  <AlertTriangle className="w-4 h-4" />
                  <AlertDescription>
                    <div>You don't have permission to access <b>Role Management.</b></div>
                  </AlertDescription>
                </Alert>
              </div>
            ) : (
              <>
                {/* Roles Header */}
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="font-inter font-semibold text-2xl leading-[100%] tracking-normal text-[#172B4D] mb-2">
                      Role Management
                    </h2>
                    <p className="font-inter font-normal text-[16px] leading-[20px] tracking-normal text-[#758195]">
                      Create and manage user roles with specific permissions
                    </p>
                  </div>
                  {(userManagementMenu?.userPermissions?.includes("roles:create")) && (
                    <Button onClick={() => { setShowCreateRoleDialog(true), resetRoleForm(), resetValidationErrors() }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white"
                    >
                      <Plus className="w-4 h-4 mr-2 text-white" />
                      Create Role
                    </Button>
                  )}
                </div>
                {userManagementMenu?.userPermissions?.includes("roles:view") && (
                  <>
                    {/* Role Filters */}
                    <Card>
                      <CardContent className="p-6">
                        <div className="flex gap-4">
                          <div className="relative flex-1">
                            <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                            <Input
                              placeholder="Search roles..."
                              value={roleSearchTerm}
                              onChange={(e) => setRoleSearchTerm(e.target.value)}
                              className="pl-10 font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]"
                            />
                          </div>
                          <Button
                            variant="outline"
                            onClick={() => {
                              resetFilters();
                              fetchRoles();
                            }}
                            className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                          >
                            <RefreshCw className="w-4 h-4 mr-2 text-[#2C3E5D]" />
                            Reset
                          </Button>
                        </div>
                      </CardContent>
                    </Card>

                    {/* Roles Table */}
                    {isLoading ? (
                      <LoadingTable
                        title="Roles"
                        columns={roleColumns}
                        rows={4}
                        showPagination={true}
                      />
                    ) : (
                      <Card>
                        <CardHeader>
                          <CardTitle className="font-inter font-medium text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                          >Roles ({roles.length})</CardTitle>
                        </CardHeader>
                        <CardContent>
                          <div className="overflow-x-auto">
                            <Table>
                              <TableHeader>
                                <TableRow >
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Role</TableHead>
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Description</TableHead>
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Users</TableHead>
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Permissions</TableHead>
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Created</TableHead>
                                  <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Actions</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {paginatedRoles.length > 0 ? (
                                  paginatedRoles.map((role) => (
                                    <TableRow key={role.id}>
                                      <TableCell>
                                        <div className="flex items-center gap-3">
                                          <div className="flex items-center gap-2">
                                            <Shield className="w-5 h-5 text-gray-600" />
                                            <div>
                                              <div className="flex items-center gap-2">
                                                <span className="font-inter font-medium text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                                  {/* {role.name} */}
                                                  {role?.displayName ?? ''}
                                                </span>
                                                {/* <p className="text-gray-500" style={{ fontSize: '10px' }}>
                                      ({role?.displayName ?? ' '})
                                    </p> */}
                                                {/* <Badge className={role.color}>
                                        {role?.name ?? ''}
                                      </Badge> */}
                                                {role?.isSystem && (
                                                  <Badge className={role.color}>
                                                    System
                                                  </Badge>
                                                )}

                                              </div>
                                              <p className=" mt-1 font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                                {role?.name ?? ' '}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </TableCell>
                                      <TableCell className='max-w-[200px]'>
                                        <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195] break-all  whitespace-normal ">

                                          {role?.description ?? ' '}
                                        </span>

                                      </TableCell>

                                      <TableCell>
                                        <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                          {/* {role.userCount || 0} */}
                                          {role?.userCount}

                                        </span>
                                      </TableCell>
                                      <TableCell>
                                        <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                          {/* {role.permissions.length} */}
                                          {role?.permissions?.length ?? 0}
                                        </span>
                                      </TableCell>
                                      <TableCell>
                                        <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                          {/* {role.createdAt ? role.createdAt.toLocaleDateString() : 'System'} */}
                                          {role?.createdAt ? new Date(role.createdAt).toLocaleDateString() : 'System'}
                                        </span>
                                      </TableCell>
                                      <TableCell>
                                        <DropdownMenu>
                                          <DropdownMenuTrigger asChild>
                                            <Button variant="ghost" size="sm">
                                              <MoreHorizontal className="w-4 h-4  text-[#2C3E5D]" />
                                            </Button>
                                          </DropdownMenuTrigger>
                                          <DropdownMenuContent align="end">


                                            <DropdownMenuItem
                                              onClick={() => openViewDialogRole(role.id)}
                                              className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                                            >
                                              <Eye className="w-4 h-4 mr-2 text-[#758195]" />
                                              View Role
                                            </DropdownMenuItem>
                                            {userManagementMenu?.userPermissions?.includes("roles:edit") && (
                                              <DropdownMenuItem onClick={() => { openEditRoleDialog(role), resetFilters() }} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                                <Edit className="w-4 h-4 mr-2 text-[#758195]" />
                                                Edit Role
                                              </DropdownMenuItem>
                                            )}
                                            {/* <DropdownMenuItem onClick={() => handleDuplicateRole(role)}>
                                  <Copy className="w-4 h-4 mr-2" />
                                  Duplicate Role
                                </DropdownMenuItem> */}
                                            {/* {role.isCustom && ( */}
                                            {/* {role?.isCustom && (
                                  <> */}
                                            {/* <DropdownMenuSeparator /> */}
                                            {userManagementMenu?.userPermissions?.includes("roles:delete") && (
                                              <DropdownMenuItem
                                                onClick={() => {
                                                  setRoleToDelete(role);
                                                  setShowDeleteRoleDialog(true);
                                                }}
                                                className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#E5102E]"
                                              >
                                                <Trash2 className="w-4 h-4 mr-2 text-[#758195]" />
                                                Delete Role
                                              </DropdownMenuItem>
                                            )}
                                            {/* </>
                                )} */}
                                          </DropdownMenuContent>
                                        </DropdownMenu>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={7} className="text-center py-8">
                                      <div className="flex flex-col items-center gap-2">
                                        {/* <Users className="w-8 h-8 text-gray-400" /> */}
                                        <p className="text-gray-500 text-sm">
                                          No Roles Found
                                        </p>
                                        {/* <Button variant="outline" size="sm"
                                  onClick={() => {
                                    setRoleSearchTerm('');
                                    setRolesPage(1);
                                  }}>
                                  Clear Filters
                                </Button> */}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </div>

                          {/* Roles Pagination */}
                          <div className="mt-6">
                            <PaginationCustom
                              currentPage={rolesPage}
                              // totalPages={Math.ceil(filteredRoles.length / rolesPerPage)}
                              // totalItems={filteredRoles.length}
                              totalPages={Math.ceil((roles?.length ?? 0) / rolesPerPage)}
                              totalItems={roles?.length ?? 0}
                              itemsPerPage={rolesPerPage}
                              onPageChange={setRolesPage}
                              onItemsPerPageChange={(newSize) => {
                                setRolesPerPage(newSize);
                                setRolesPage(1);
                              }}
                            />
                          </div>
                        </CardContent>
                      </Card>
                    )}
                  </>
                )}
              </>
            )}
          </TabsContent>

          <TabsContent value="permissions" className="space-y-6">
            {(!userManagementMenu?.userPermissions?.includes("roles:view")) ? (
              <div className="p-6">
                <Alert>
                  <AlertTriangle className="w-4 h-4" />
                  <AlertDescription>
                    <div>You don't have permission to view <b>Permissions.</b></div>
                  </AlertDescription>
                </Alert>
              </div>
            ) : (
              <>
                {/* Permissions Header */}
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="font-inter font-semibold text-2xl leading-[100%] tracking-normal text-[#172B4D] mb-2">
                      Permission Management
                    </h2>
                    <p className="font-inter font-normal text-[16px] leading-[20px] tracking-normal text-[#758195]">
                      Permissions overview
                    </p>
                  </div>
                  {/* <Button onClick={() => { setShowCreatePermissionDialog(true), resetPermissionForm() }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white">
                <Plus className="w-4 h-4 mr-2 text-white" />
                Create Permission
              </Button> */}
                </div>

                {/* Permission Filters */}
                <Card>
                  <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="relative">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <Input
                          placeholder="Search permissions..."
                          value={permissionSearchTerm ?? ''}
                          onChange={(e) => setPermissionSearchTerm(e.target.value)}
                          className="pl-10 font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]"
                        />
                      </div>
                      <Select value={selectedCategory ?? 'all'} onValueChange={setSelectedCategory}>
                        <SelectTrigger className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]">
                          <SelectValue placeholder="All Categories" />
                        </SelectTrigger>

                        <SelectContent className='max-h-40 overflow-y-auto'>
                          <SelectItem
                            value="all"
                            className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]"
                          >
                            All Categories
                          </SelectItem>
                          {uniqueCategories.map((key) => (
                            <SelectItem
                              key={key}
                              value={key}
                              className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]"
                            >
                              {key}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      {/* <Select value={selectedCategory ?? 'all'} onValueChange={setSelectedCategory}>
                    <SelectTrigger>
                      <SelectValue placeholder="All Categories" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Categories</SelectItem>
                      {uniqueCategories.map((category) => (
                        <SelectItem key={category} value={category}>
                          {category.charAt(0).toUpperCase() + category.slice(1)}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select> */}
                      <Button
                        variant="outline"
                        onClick={() => {
                          resetFilters();
                        }}
                        className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                      >
                        <RefreshCw className="w-4 h-4 mr-2 text-[#2C3E5D]" />
                        Reset
                      </Button>
                    </div>
                  </CardContent>
                </Card>

                {/* Permissions Table */}

                {isLoading ? (
                  <LoadingTable
                    title="Permissions"
                    columns={permissionColumns}
                    rows={5}
                    showPagination={true}
                  />
                ) : (
                  <Card>
                    <CardHeader>
                      <CardTitle className='font-inter font-medium text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]'>
                        Permissions ({filteredPermissions?.length ?? 0})
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <div className="overflow-x-auto">
                        <Table>
                          <TableHeader>
                            <TableRow>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Permission</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Description</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Category</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Used in Roles</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Created</TableHead>
                              <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Action</TableHead>
                              {/* <TableHead className="font-inter font-semibold text-[12px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Actions</TableHead> */}
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {/* {paginatedPermissions.map((permission) => {
                        // const rolesWithPermission = roles.filter(role =>
                    //   role.permissions.includes(permission.id)
                    // );
                    {(paginatedPermissions ?? []).map((permission) => {
                        const rolesWithPermission = (roles ?? []).filter((role) =>
                          (role?.permissions ?? []).includes(permission?.id)
                        );
                        return ( */}
                            {paginatedPermissions?.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} className="text-center py-8">
                                  <div className="flex flex-col items-center gap-2">
                                    {/* <Users className="w-8 h-8 text-gray-400" /> */}
                                    <p className="text-gray-500 text-sm">
                                      No Permissions Found
                                    </p>
                                    {/* <Button variant="outline" size="sm" onClick={() => {
                                setPermissionSearchTerm('');
                                setSelectedCategory('all');
                                setPermissionsPage(1);
                              }}>
                                Clear Filters
                              </Button> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ) : (
                              paginatedPermissions.map((permission) => (
                                <TableRow key={permission?.id}>
                                  <TableCell>
                                    <div>
                                      <div className="flex items-center gap-2">
                                        <span className="font-inter font-medium text-sm leading-5 tracking-normal text-[#44546F]">
                                          {permission?.name ?? ''}
                                        </span>
                                        {/* {permission?.isCustom && (
                                                                        <Badge className="bg-purple-100 text-purple-800">
                                                                            Custom
                                                                        </Badge>
                                                                    )} */}
                                      </div>
                                      {/* <p className="text-gray-500 font-bold" style={{ fontSize: '10px' }}>
                                  {permission?.action + " " + permission?.category}
                                </p> */}

                                      {/* <p className="font-inter font-normal text-[12px] leading-[100%] tracking-normal text-[#758195]  break-words whitespace-normal max-w-xs">
                                  {permission?.description}
                                </p> */}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195] break-words whitespace-normal max-w-xs">
                                      {permission?.description}
                                    </span>
                                  </TableCell>
                                  <TableCell>
                                    <Badge variant="outline" className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#2C3E5D]"
                                    >
                                      {/* {permission?.category.charAt(0).toUpperCase() + permission.category.slice(1)} */}
                                      {(permission?.category?.charAt(0).toUpperCase() ?? '') +
                                        (permission?.category?.slice(1) ?? '')}
                                    </Badge>
                                  </TableCell>
                                  <TableCell>
                                    <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                      {/* {rolesWithPermission.length} */}
                                      {permission.roleCount ?? 0}
                                    </span>
                                  </TableCell>
                                  <TableCell>
                                    <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                      {/* {permission.createdAt ? permission.createdAt.toLocaleDateString() : 'System'} */}
                                      {permission?.createdAt
                                        ? new Date(permission.createdAt).toLocaleDateString()
                                        : 'System'}

                                    </span>
                                  </TableCell>
                                  <TableCell>
                                    <span className="font-inter font-normal text-[14px] leading-[100%] tracking-normal text-[#758195]">
                                      {/* {permission.createdAt ? permission.createdAt.toLocaleDateString() : 'System'} */}
                                      {permission?.action}
                                    </span>
                                  </TableCell>
                                  <TableCell>
                                    {/* <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <Button variant="ghost" size="sm">
                                    <MoreHorizontal className="w-4 h-4 text-[#2C3E5D]" />
                                  </Button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end">

                                  <DropdownMenuItem onClick={() => openEditPermissionDialog(permission)} className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                                    <Edit className="w-4 h-4 mr-2 text-[#758195]" />
                                    Edit Permission
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    onClick={() => {
                                      setPermissionToDelete(permission);
                                      setShowDeletePermissionDialog(true);
                                    }}
                                    className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#E5102E]"
                                  >
                                    <Trash2 className="w-4 h-4 mr-2 text-[#758195]" />
                                    Delete Permission
                                  </DropdownMenuItem>
                                  {permission?.isCustom && (
                                    <>
                                      <DropdownMenuSeparator />
                                      <DropdownMenuItem
                                        onClick={() => {
                                          setPermissionToDelete(permission);
                                          setShowDeletePermissionDialog(true);
                                        }}
                                        className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#E5102E]"
                                      >
                                        <Trash2 className="w-4 h-4 mr-2 text-[#758195]" />
                                        Delete Permission
                                      </DropdownMenuItem>
                                    </>
                                  )}
                                </DropdownMenuContent>
                              </DropdownMenu> */}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </div>

                      {/* Permissions Pagination */}
                      <div className="mt-6">
                        <PaginationCustom
                          currentPage={permissionsPage}
                          totalPages={Math.ceil(filteredPermissions?.length / permissionsPerPage)}
                          totalItems={filteredPermissions?.length}
                          itemsPerPage={permissionsPerPage}
                          onPageChange={setPermissionsPage}
                          onItemsPerPageChange={(newSize) => {
                            setPermissionsPerPage(newSize);
                            setPermissionsPage(1);
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                )}
              </>
            )}
          </TabsContent>
        </Tabs>

        {/* Create User Dialog */}
        <Dialog open={showCreateDialog} onOpenChange={setShowCreateDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">
                Create New User
              </DialogTitle>
              <DialogDescription className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'>
                Add a new user to the healthcare audit system
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="firstName" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                    First Name *
                  </Label>
                  <Input
                    id="firstName"
                    value={formData.firstName}
                    onChange={(e) => handleInputChange('firstName', e.target.value)}
                    onBlur={() => handleFieldBlur('firstName')}
                    placeholder="Enter the first name"
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.firstName ? 'border-red-500' : ''
                      }`}
                  />

                  {validationErrors.firstName && (
                    <p className="text-red-500 text-xs mt-1">{validationErrors.firstName}</p>
                  )}
                </div>

                <div>
                  <Label htmlFor="lastName" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                    Last Name *
                  </Label>
                  <Input
                    id="lastName"
                    value={formData.lastName}
                    onChange={(e) => handleInputChange('lastName', e.target.value)}
                    onBlur={() => handleFieldBlur('lastName')}
                    placeholder="Enter the last name"
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.lastName ? 'border-red-500' : ''
                      }`}
                  />

                  {validationErrors.lastName && (
                    <p className="text-red-500 text-xs mt-1">{validationErrors.lastName}</p>
                  )}
                </div>
              </div>

              <div>
                <Label htmlFor="email" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                  Email *
                </Label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  onBlur={() => handleFieldBlur('email')}
                  placeholder="Enter the email address"
                  className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.email ? 'border-red-500' : ''
                    }`}
                />

                {validationErrors.email && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.email}</p>
                )}
              </div>

              {/* 
              <div>
                <Label htmlFor="password" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                  Password *
                </Label>
                <Input
                  id="password"
                  type="password"
                  value={formData.password}
                  onChange={(e) => handleInputChange('password', e.target.value)}
                  onBlur={() => handleFieldBlur('password')}
                  placeholder="Enter the password"
                  className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.password ? 'border-red-500' : ''
                    }`}
                />

                {validationErrors.password && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.password}</p>
                )}
              </div>
              */}

              <div>
                <Label
                  htmlFor="password"
                  className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                >
                  Password *
                </Label>

                <div className="relative">
                  <Input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => handleInputChange("password", e.target.value)}
                    onBlur={() => handleFieldBlur("password")}
                    placeholder="Enter the password"
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] pr-10 ${validationErrors.password ? "border-red-500" : ""
                      }`}
                  />

                  {/* Toggle Button */}
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                  >
                    {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
                  </button>
                </div>

                {validationErrors.password && (
                  <p className="text-red-500 text-xs mt-1">
                    {validationErrors.password}
                  </p>
                )}
              </div>

              <div>
                <Label
                  htmlFor="phone"
                  className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                >
                  Phone Number (Optional)
                </Label>

                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pr-2 text-gray-600 text-sm pointer-events-none">
                    +1
                    <span className="h-5 border-l border-gray-300 ml-2"></span>
                  </span>

                  <Input
                    id="phone"
                    type="tel"
                    value={formData.phoneNumber}
                    onChange={(e) =>
                      handlePhoneChange(e.target.value.replace(/\D/g, '').slice(0, 10))
                    }
                    onBlur={() => handleFieldBlur('phoneNumber')}
                    placeholder="Enter the phone number"
                    className={`pl-14 font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.phoneNumber ? 'border-red-500' : ''
                      }`}
                  />
                </div>

                {validationErrors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-1">
                    {validationErrors.phoneNumber}
                  </p>
                )}
              </div>



              <div>
                <Label htmlFor="role" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                  Role *
                </Label>
                <Select
                  value={formData.roleIds[0] || ""}
                  onValueChange={(value) => handleInputChange('roleIds', [value])}

                >
                  <SelectTrigger className={validationErrors.roleIds ? 'border-red-500' : ''}>
                    <SelectValue placeholder="Select role" />
                  </SelectTrigger>
                  <SelectContent className="max-h-40 w-100% overflow-y-auto rounded-lg shadow-lg border border-gray-200 bg-white text-[#758195]">
                    {roles.map(role => (
                      <SelectItem key={role.id} value={role.id}>
                        {role?.displayName}   <span className="text-xs text-gray-500">({role?.name})</span>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {validationErrors.roleIds && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.roleIds}</p>
                )}
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label htmlFor="isActive" className="mb-2 font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                    Account Active
                  </Label>
                  <Switch
                    id="isActive"
                    checked={formData.isActive}
                    className="data-[state=unchecked]:bg-gray-300"
                    onCheckedChange={(checked) => setFormData(prev => ({ ...prev, isActive: checked }))}
                  />
                </div>
              </div>
            </div>

            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => {
                  setShowCreateDialog(false);
                  clearValidationErrors();
                }}
                className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
              >
                Cancel
              </Button>
              <Button
                onClick={handleCreateUser}
                className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white"
              >
                Create User
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {showViewDialog && viewUserData && (
          <Dialog open={showViewDialog} onOpenChange={setShowViewDialog}>
            <DialogContent className="max-w-lg">
              <DialogHeader>
                <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-[0] text-[#172B4D]">View User</DialogTitle>
                <DialogDescription className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">
                  Complete information about "{viewUserData.firstName}  {viewUserData.lastName}"
                </DialogDescription>
              </DialogHeader>

              <div className="mt-4 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Name</p>
                    <p className="font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1">
                      {viewUserData.firstName} {viewUserData.lastName}
                    </p>
                  </div>
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Role</p>
                    <span
                      className="inline-flex px-2 py-1 font-inter font-normal text-[12px] leading-[100%] tracking-[0] rounded-md bg-red-100 text-red-600 mt-1"
                    >
                      {viewUserData.roles?.length
                        ? viewUserData.roles.map((r) => r.displayName).join(", ")
                        : "No Role"}
                    </span>
                  </div>
                </div>

                {/* Email + Status */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Email</p>
                    <p className="font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1 break-all">{viewUserData.email || "N/A"}</p>
                  </div>
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Status</p>
                    <span
                      className={`inline-flex px-2 py-1 mt-1 font-inter font-normal text-[12px] leading-[100%] tracking-[0] rounded-md ${viewUserData.isActive
                        ? "bg-green-100 text-green-600"
                        : "bg-gray-200 text-gray-600"
                        }`}
                    >
                      {viewUserData.isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
                <hr className="border-t border-gray-200" />

                {/* Last Login + Last Activity */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Last Login</p>

                    <p className="flex items-center font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1">
                      <Clock className="w-4 h-4 mr-2 text-[#758195]" />
                      {viewUserData?.lastLogin
                        ? new Date(viewUserData?.lastLogin).toLocaleString()
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Last Activity</p>
                    <p className="flex items-center font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1">
                      <Activity className="w-4 h-4 mr-2 text-[#758195]" />
                      {viewUserData?.updatedAt
                        ? new Date(viewUserData?.updatedAt).toLocaleString()
                        : "N/A"}
                    </p>

                  </div>
                </div>
                {/* {Account Created + Total permission} */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Account Created</p>
                    <p className="flex items-center font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1">
                      <Calendar className="w-4 h-4 mr-2 text-[#758195]" />
                      {viewUserData?.createdAt
                        ? new Date(viewUserData?.createdAt).toLocaleString()
                        : "N/A"}

                    </p>
                  </div>
                  <div>
                    <p className="font-inter font-normal text-[14px] leading-[100%] tracking-[0] text-[#2C3E5D]">Total Permissions</p>
                    <p className="flex items-center font-inter font-normal text-[14px] leading-[20px] tracking-[0] text-[#758195] mt-1">
                      <Shield className="w-4 h-4 mr-2 text-[#758195]" />
                      {viewUserData?.permissions?.length}

                    </p>
                  </div>
                </div>

              </div>

              <DialogFooter className="mt-6">
                <Button variant="secondary" onClick={() => setShowViewDialog(false)} className="font-inter font-semibold text-[14px] leading-[20px] tracking-[0] text-[#2C3E5D]">
                  Close
                </Button>
                {/* <Button
                  onClick={() => openEditDialog(viewUserData)}
                  className="font-inter font-semibold text-[14px] leading-[20px] tracking-[0]text-[#FFFFFF]">
                  Edit User
                </Button> */}
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}


        {/* Edit User Dialog */}
        <Dialog open={showEditDialog} onOpenChange={setShowEditDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">Edit User</DialogTitle>
              <DialogDescription className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'>
                Update user details for "{formData.firstName}"
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="editFirstName" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                    First Name *
                  </Label>
                  <Input
                    id="editFirstName"
                    value={formData.firstName}
                    onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
                    onBlur={() => handleFieldBlur('firstName')}
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.firstName ? 'border-red-500' : ''
                      }`}
                  />
                  {validationErrors.firstName && (
                    <p className="text-red-500 text-xs mt-1">{validationErrors.firstName}</p>
                  )}
                </div>
                <div>
                  <Label htmlFor="editLastName" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                    Last Name (Optional)
                  </Label>
                  <Input
                    id="editLastName"
                    value={formData.lastName}
                    onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
                    onBlur={() => handleFieldBlur('lastName')}
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.lastName ? 'border-red-500' : ''
                      }`}
                  />
                  {validationErrors.lastName && (
                    <p className="text-red-500 text-xs mt-1">{validationErrors.lastName}</p>
                  )}
                </div>
              </div>

              <div>
                <Label htmlFor="editEmail" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Email</Label>
                <Input
                  id="editEmail"
                  type="email"
                  value={formData.email}
                  disabled
                  onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label
                  htmlFor="editPhone"
                  className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                >
                  Phone Number (Optional)
                </Label>

                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pr-2 text-gray-600 text-sm pointer-events-none">
                    +1
                    <span className="h-5 border-l border-gray-300 ml-2"></span>
                  </span>

                  <Input
                    id="phone"
                    type="tel"
                    value={formData.phoneNumber}
                    onChange={(e) =>
                      handlePhoneChange(e.target.value.replace(/\D/g, '').slice(0, 10))
                    }
                    onBlur={() => handleFieldBlur('phoneNumber')}
                    placeholder="Enter the phone number"
                    maxLength={10}
                    className={`pl-14 font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.phoneNumber ? 'border-red-500' : ''
                      }`}
                  />
                </div>

                {validationErrors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.phoneNumber}</p>
                )}
              </div>


              <div>
                <Label htmlFor="editRole" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                  Role
                </Label>
                <Select
                  value={formData.role}
                  onValueChange={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      role: value,
                      roleIds: [value],
                    }))
                  }
                >
                  <SelectTrigger className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${validationErrors.roleIds ? 'border-red-500' : ''
                    }`}>
                    <SelectValue placeholder="Select a role" />
                  </SelectTrigger>
                  <SelectContent className='max-h-40 w-100% overflow-y-auto rounded-lg shadow-lg border border-gray-200 bg-white  text-[#758195]'>
                    {roles.map((role) => (
                      <SelectItem key={role.id} value={role.id}>
                        {role?.displayName}   <span className="text-xs text-gray-500">({role?.name})</span>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {validationErrors.roleIds && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.roleIds}</p>
                )}
              </div>


              {/* <div>
                <Label htmlFor="editDepartment" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Department</Label>
                <Select value={formData.department} onValueChange={(value) => setFormData(prev => ({ ...prev, department: value }))}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {departments.map(dept => (
                      <SelectItem key={dept} value={dept}>
                        {dept}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div> */}

              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label htmlFor="editIsActive" className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Account Active</Label>
                  <Switch
                    id="editIsActive"
                    checked={formData.isActive}
                    disabled
                    onCheckedChange={(checked) => setFormData(prev => ({ ...prev, isActive: checked }))}
                  />
                </div>

                {/* <div className="flex items-center justify-between">
                  <Label htmlFor="editTwoFactorEnabled" className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Two-Factor Authentication</Label>
                  <Switch
                    id="editTwoFactorEnabled"
                    checked={formData.twoFactorEnabled}
                    onCheckedChange={(checked) => setFormData(prev => ({ ...prev, twoFactorEnabled: checked }))}
                  />
                </div> */}

                {/* <div className="flex items-center justify-between">
                  <Label htmlFor="editRequiresPasswordReset" className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Require Password Reset</Label>
                  <Switch
                    id="editRequiresPasswordReset"
                    checked={formData.requiresPasswordReset}
                    onCheckedChange={(checked) => setFormData(prev => ({ ...prev, requiresPasswordReset: checked }))}
                  />
                </div> */}
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline"
                onClick={() => {
                  resetForm();               // clear state
                  setSelectedUser(null);     // optional: clear selected user
                  setShowEditDialog(false);  // close dialog
                }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                Cancel
              </Button>
              <Button onClick={handleEditUser} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white">
                Update User
              </Button>
            </DialogFooter>

          </DialogContent>

        </Dialog>

        {/* Delete User Confirmation */}
        <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Delete User</AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to delete {userToDelete?.firstName} {userToDelete?.lastName}?
                This action cannot be undone and will permanently remove the user account and all associated data.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDeleteUser} className="bg-red-600 hover:bg-red-700">
                Delete User
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        {/* Create Role Dialog */}
        <Dialog open={showCreateRoleDialog} onOpenChange={setShowCreateRoleDialog}>
          <DialogContent className="max-w-2xl ">
            <DialogHeader>
              <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">Create New Role</DialogTitle>
              <DialogDescription>
                Define a new role with specific permissions
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label
                    htmlFor="roleName"
                    className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                  >
                    Name*
                  </Label>

                  <Input
                    id="roleName"
                    value={roleFormData.name}
                    onChange={(e) =>
                      setRoleFormData((prev) => ({ ...prev, name: e.target.value }))
                    }
                    onBlur={() => handleRoleFieldBlur("name")}
                    placeholder="Enter the name"
                    maxLength={50} // prevent typing beyond 50
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${roleValidationErrors.name ? "border-red-500" : ""
                      }`}
                  />

                  {roleValidationErrors.name && (
                    <p className="text-red-500 text-xs mt-1">{roleValidationErrors.name}</p>
                  )}
                </div>

                <div>
                  <Label
                    htmlFor="displayName"
                    className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                  >
                    Display Name*
                  </Label>

                  <Input
                    id="displayName"
                    value={roleFormData.displayName}
                    onChange={(e) =>
                      setRoleFormData((prev) => ({ ...prev, displayName: e.target.value }))
                    }
                    onBlur={() => handleRoleFieldBlur("displayName")}
                    placeholder="Enter the display name"
                    maxLength={50} // ✅ limit typing to 50 chars
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${roleValidationErrors.displayName ? "border-red-500" : ""
                      }`}
                  />

                  {roleValidationErrors.displayName && (
                    <p className="text-red-500 text-xs mt-1">{roleValidationErrors.displayName}</p>
                  )}
                </div>
                {/* <div>
                  <Label htmlFor="roleColor">Color</Label>
                  <Select value={roleFormData.color} onValueChange={(value) => setRoleFormData(prev => ({ ...prev, color: value }))}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {roleColorOptions.map(color => (
                        <SelectItem key={color} value={color}>
                          <div className="flex items-center gap-2">
                            <div className={`w-3 h-3 rounded ${color}`} />
                            <span className="capitalize">
                              {color.split('-')[1]} {color.split('-')[2]?.split(' ')[0]}
                            </span>
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div> */}
              </div>

              <div>
                <Label htmlFor="roleDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Description*</Label>
                <Textarea
                  id="roleDescription"
                  value={roleFormData.description}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, description: e.target.value }))}
                  onBlur={() => handleRoleFieldBlur("description")}
                  placeholder="Enter the role description"
                  rows={3}
                  maxLength={250}
                  className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${roleValidationErrors.description ? "border-red-500" : ""
                    }`}
                />
                {roleValidationErrors.description && (
                  <p className="text-red-500 text-xs mt-1">{roleValidationErrors.description}</p>
                )}
              </div>

              <div>
                <Label className="font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Permissions*</Label>
                {roleValidationErrors && <p className="text-red-500 text-xs mt-1">{roleValidationErrors.permissionIds}</p>}
                {/* <div className="mt-2 border border-gray-200 rounded-lg p-4 max-h-80 overflow-y-auto">
                  {['system', 'user', 'audit', 'report'].map(category => (
                    <div key={category} className="mb-4">
                      <h4 className="font-medium text-gray-900 mb-2 capitalize" style={{ fontSize: '12px' }}>
                        {category} Permissions
                      </h4>
                      <div className="space-y-2">
                        {permissions
                          .filter(permission => permission?.category === category)
                          .map(permission => (
                            <div key={permission?.id} className="flex items-start gap-2">
                              <Checkbox
                                id={permission?.id}
                                checked={roleFormData.permissionIds?.includes(permission?.id)} // ✅ corrected
                                onCheckedChange={(checked) => {
                                  if (checked) {
                                    setRoleFormData(prev => ({
                                      ...prev,
                                      permissionIds: [...prev.permissionIds, permission?.id]
                                    }));
                                  } else {
                                    setRoleFormData(prev => ({
                                      ...prev,
                                      permissionIds: prev.permissionIds.filter(p => p !== permission?.id)
                                    }));
                                  }
                                }}
                              />
                              <div>
                                <Label htmlFor={permission.id} className="text-gray-900" style={{ fontSize: '11.2px' }}>
                                  {permission?.name}
                                </Label>
                                <p className="text-gray-500" style={{ fontSize: '10px' }}>
                                  {permission?.description}
                                </p>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
                </div> */}
                <div className="mt-2 border border-gray-200 rounded-lg p-4 max-h-60 overflow-y-auto">
                  {Object.entries(permissions).map(([category, permissionList]) => (

                    <div key={category} className="mb-4">

                      <h4 className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                        {category.charAt(0).toUpperCase() + category.slice(1)} Permissions
                      </h4>
                      <div className="space-y-2">
                        {Array.isArray(permissionList) &&
                          permissionList?.map((permission) => (
                            <div key={permission.id} className="flex items-start gap-2">
                              <Checkbox
                                id={permission.id}
                                checked={roleFormData.permissionIds.includes(permission.id)}
                                onCheckedChange={(checked) => {
                                  // update permissionIds for role form data
                                  setRoleFormData(prev => ({
                                    ...prev,
                                    permissionIds: checked
                                      ? [...prev.permissionIds, permission.id]
                                      : prev.permissionIds.filter(p => p !== permission.id)
                                  }));

                                  // update selectedPermissions (id + action)
                                  // setSelectedPermissions(prev => {
                                  //   if (checked) {
                                  //     const alreadyExists = prev.some(p => p.id === permission.id);
                                  //     if (!alreadyExists) {
                                  //       return [...prev, { id: permission.id, action: permission.action }];
                                  //     }
                                  //     return prev;
                                  //   } else {
                                  //     return prev.filter(p => p.id !== permission.id);
                                  //   }
                                  // });
                                }}
                              />
                              <div>
                                <Label htmlFor={permission.id} className="mb-2 font-inter font-semibold text-[14px] leading-[100%] tracking-normal text-[#2C3E5D]">
                                  {permission.action}
                                </Label>
                                {/* <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]">
                                  {permission.description}
                                </p> */}
                              </div>
                            </div>
                          ))}
                      </div>

                    </div>
                  ))}
                </div>



              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => { setShowCreateRoleDialog(false), resetRoleForm(), resetValidationErrors() }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                Cancel
              </Button>
              <Button onClick={handleCreateRole} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white">
                Create Role
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {showViewRoleDialog && viewRoleData && (
          <Dialog open={showViewRoleDialog} onOpenChange={setShowViewRoleDialog}>
            <DialogContent className="max-w-2xl">
              <DialogHeader>
                <DialogTitle className="mb-2 font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">
                  View Role
                </DialogTitle>
                <DialogDescription>
                  Role information about "{viewRoleData?.displayName}"
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="Name" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#758195]">
                      Name
                    </Label>
                    <Input
                      id="roleName"
                      value={viewRoleData.name || ""}
                      readOnly
                      disabled
                      className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2] bg-gray-100 cursor-not-allowed'
                    />
                  </div>
                  <div>
                    <Label htmlFor="displayName" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                      Display Name
                    </Label>
                    <Input
                      id="displayName"
                      value={viewRoleData.displayName || ""}
                      readOnly
                      disabled
                      className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] bg-gray-100 cursor-not-allowed'
                    />
                  </div>
                </div>

                <div>
                  <Label htmlFor="roleDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                    Description
                  </Label>
                  <Textarea
                    id="roleDescription"
                    value={viewRoleData.description || ""}
                    readOnly
                    disabled
                    rows={3}
                    className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] bg-gray-100 cursor-not-allowed'
                  />
                </div>

                <div>
                  <Label className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                    Permissions
                  </Label>

                  <div className="mt-2 border border-gray-200 rounded-lg p-4 max-h-60 overflow-y-auto">
                    {Object.entries(permissions).map(([category, permissionList]) => (
                      <div key={category} className="mb-4">
                        <h4 className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                          {category} Permissions
                        </h4>
                        <div className="space-y-2">
                          {Array.isArray(permissionList) &&
                            permissionList.map((permission) => {
                              const isChecked = viewRoleData.permissions?.some(p => p.id === permission.id);
                              return (
                                <div key={permission.id} className="flex items-start gap-2">
                                  <Checkbox
                                    id={permission.id}
                                    checked={isChecked}
                                    disabled
                                  />
                                  <div>
                                    <Label htmlFor={permission.id} className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                                      {permission.action}
                                    </Label>
                                    {/* <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]">
                                      {permission.description}
                                    </p> */}
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <DialogFooter>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowViewRoleDialog(false);
                    setViewRoleData(null);
                  }}
                  className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
                >
                  Close
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}
        {/* Edit Role Dialog */}
        <Dialog open={showEditRoleDialog} onOpenChange={setShowEditRoleDialog}>
          <DialogContent className="max-w-2xl ">
            <DialogHeader>
              <DialogTitle className="mb-2 font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">Edit Role</DialogTitle>
              <DialogDescription>
                Update role details
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="Name" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"> Name</Label>
                  <Input
                    id="roleName"
                    value={roleFormData.name}
                    disabled
                    onChange={(e) => setRoleFormData(prev => ({ ...prev, name: e.target.value }))}
                    placeholder="Enter the role name"
                    className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[ #758195]'
                  />
                </div>
                <div>
                  <Label
                    htmlFor="displayName"
                    className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                  >
                    Display Name*
                  </Label>

                  <Input
                    id="displayName"
                    value={roleFormData.displayName}
                    onChange={(e) =>
                      setRoleFormData((prev) => ({ ...prev, displayName: e.target.value }))
                    }
                    onBlur={() => handleRoleFieldBlur("displayName")}
                    placeholder="Enter the display name"
                    maxLength={50} // ✅ limit typing to 50 chars
                    className={`font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195] ${roleValidationErrors.displayName ? "border-red-500" : ""
                      }`}
                  />

                  {roleValidationErrors.displayName && (
                    <p className="text-red-500 text-xs mt-1">{roleValidationErrors.displayName}</p>
                  )}
                </div>
                {/* <div>
                  <Label htmlFor="editRoleColor">Color</Label>
                  <Select value={roleFormData.color} onValueChange={(value) => setRoleFormData(prev => ({ ...prev, color: value }))}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {roleColorOptions.map(color => (
                        <SelectItem key={color} value={color}>
                          <div className="flex items-center gap-2">
                            <div className={`w-3 h-3 rounded ${color}`} />
                            <span className="capitalize">
                              {color.split('-')[1]} {color.split('-')[2]?.split(' ')[0]}
                            </span>
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div> */}
              </div>

              <div>
                <Label htmlFor="roleDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Description*</Label>
                <Textarea
                  id="roleDescription"
                  value={roleFormData.description}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, description: e.target.value }))}
                  onBlur={() => handleRoleFieldBlur("description")}
                  placeholder="Enter the role description"
                  rows={3}
                  maxLength={250}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>



              {/* <div className="space-y-2">
                        {permissions
                          .filter(permission => permission.category === category)
                          .map(permission => (
                            <div key={permission.id} className="flex items-start gap-2">
                              <Checkbox
                                id={`edit-${permission.id}`}
                                checked={roleFormData.permissions.includes(permission.id)}
                                onCheckedChange={(checked) => {
                                  if (checked) {
                                    setRoleFormData(prev => ({
                                      ...prev,
                                      permissions: [...prev.permissions, permission.id]
                                    }));
                                  } else {
                                    setRoleFormData(prev => ({
                                      ...prev,
                                      permissions: prev.permissions.filter(p => p !== permission.id)
                                    }));
                                  }
                                }}
                              />
                              <div>
                                <Label htmlFor={`edit-${permission.id}`} className="text-gray-900" style={{ fontSize: '11.2px' }}>
                                  {permission.name}
                                </Label>
                                <p className="text-gray-500" style={{ fontSize: '10px' }}>
                                  {permission.description}
                                </p>
                              </div>
                            </div>
                          ))}
                      </div> */}

              <div>
                <Label className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Permissions*</Label>
                {roleValidationErrors && <p className="text-red-500 text-sm">{roleValidationErrors.permissionIds}</p>}

                <div className="mt-2 border border-gray-200 rounded-lg p-4 max-h-60 overflow-y-auto">
                  {Object.entries(permissions).map(([category, permissionList]) => (
                    <div key={category} className="mb-4">
                      <h4 className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                        {category} Permissions
                      </h4>
                      <div className="space-y-2">
                        {Array.isArray(permissionList) &&
                          permissionList.map((permission): any => {
                            return (
                              <div key={permission.id} className="flex items-start gap-2">
                                <Checkbox
                                  id={permission.id}
                                  checked={roleFormData.permissionIds.includes(permission.id)}
                                  onCheckedChange={(checked) => {
                                    setRoleFormData(prev => {
                                      let updatedPermissionIds = checked
                                        ? [...prev.permissionIds, permission.id]
                                        : prev.permissionIds.filter(p => p !== permission.id);

                                      updatedPermissionIds = Array.from(new Set(updatedPermissionIds));

                                      return {
                                        ...prev,
                                        permissionIds: updatedPermissionIds,
                                      };
                                    });


                                    // setSelectedPermissions(prev => {
                                    //   if (checked) {
                                    //     const alreadyExists = prev.some(p => p.id === permission.id);
                                    //     if (!alreadyExists) {
                                    //       return [...prev, { id: permission.id, action: permission.action }];
                                    //     }
                                    //     return prev;
                                    //   } else {
                                    //     return prev.filter(p => p.id !== permission.id);
                                    //   }
                                    // });
                                  }}
                                />
                                <div>
                                  <Label htmlFor={permission.id} className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">
                                    {permission.action}
                                  </Label>
                                  {/* <p className="font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]">
                                    {permission.description}
                                  </p> */}
                                </div>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => { setShowEditRoleDialog(false), resetRoleForm() }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                Cancel
              </Button>
              <Button onClick={handleEditRole} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white"
              >
                Update Role
              </Button>
            </DialogFooter>

          </DialogContent>
        </Dialog>

        {/* Delete Role Confirmation */}
        <AlertDialog open={showDeleteRoleDialog} onOpenChange={setShowDeleteRoleDialog}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Delete Role</AlertDialogTitle>
              {/* <AlertDialogDescription>
                Are you sure you want to delete the role "{roleToDelete?.name}"?
                This action cannot be undone. Users with this role will need to be reassigned.
              </AlertDialogDescription> */}
              <AlertDialogDescription>
                Are you sure you want to delete the role "{roleToDelete?.name}"?{" "}
                {(roleToDelete?.userCount ?? 0) > 0
                  ? "Users with this role will need to be reassigned."
                  : "This action cannot be undone."}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDeleteRole} className="bg-red-600 hover:bg-red-700">
                Delete Role
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        {/* Create Permission Dialog */}
        {/* <Dialog open={showCreatePermissionDialog} onOpenChange={setShowCreatePermissionDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">Create New Permission</DialogTitle>
              <DialogDescription className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]'>
                Define a new system permission
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
              <div>
                <Label htmlFor="permissionName" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Permission Name</Label>
                <Input
                  id="permissionName"
                  value={permissionFormData.name}
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, name: e.target.value }))}
                  placeholder="Enter permission name"
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label htmlFor="permissionDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Description</Label>
                <Textarea
                  id="permissionDescription"
                  value={permissionFormData.description}
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, description: e.target.value }))}
                  placeholder="Enter permission description"
                  rows={3}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label htmlFor="permissionAction" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Action</Label>
                <Input
                  id="permissionAction"
                  value={permissionFormData.action}
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, action: e.target.value }))}
                  placeholder="Enter permission action"
                  // rows={5}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label htmlFor="permissionCategory" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Category</Label>
                <Select value={permissionFormData.category} onValueChange={(value) => setPermissionFormData(prev => ({ ...prev, category: value as Permission['category'] }))}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Users" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Users</SelectItem>
                    <SelectItem value="Prompts" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Prompts</SelectItem>
                    <SelectItem value="Audits" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Audits</SelectItem>
                    <SelectItem value="Roles" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Roles</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label
                  htmlFor="permissionCategory"
                  className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                >
                  Category
                </Label>

                <Select
                  value={permissionFormData.category}
                  onValueChange={(value) =>
                    setPermissionFormData((prev) => ({
                      ...prev,
                      category: value as Permission['category'],
                    }))
                  }
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>
                  <SelectContent className="max-h-40 overflow-y-auto">
                    {permissionCategories.map((cat) => (
                      <SelectItem
                        key={cat}
                        value={cat}
                        className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                      >
                        {cat}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label htmlFor="permissionAction" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Action</Label>
                <Input
                  id="permissionAction"
                  value={permissionFormData.action}
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, action: e.target.value }))}
                  placeholder="Enter permission action"
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]'
                />
              </div>

            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => setShowCreatePermissionDialog(false)} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]"
              >
                Cancel
              </Button>
              <Button onClick={handleCreatePermission} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white">
                Create Permission
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog> */}

        {/* Edit Permission Dialog */}
        {/* <Dialog open={showEditPermissionDialog} onOpenChange={setShowEditPermissionDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="font-inter font-semibold text-[20px] leading-[100%] tracking-normal text-[#2C3E5D]">Edit Permission</DialogTitle>
              <DialogDescription className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#8590A2]'>
                Update permission information
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
              <div>
                <Label htmlFor="editPermissionName" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Permission Name</Label>
                <Input
                  id="editPermissionName"
                  value={permissionFormData.name}
                  disabled
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, name: e.target.value }))}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label htmlFor="editPermissionDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Description</Label>
                <Textarea
                  id="editPermissionDescription"
                  value={permissionFormData.description}
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, description: e.target.value }))}
                  rows={3}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

              <div>
                <Label htmlFor="editPermissionDescription" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Action</Label>
                <Textarea
                  id="editPermissionAction"
                  value={permissionFormData.action}
                  disabled
                  onChange={(e) => setPermissionFormData(prev => ({ ...prev, action: e.target.value }))}
                  rows={1}
                  className='font-inter font-normal text-[14px] leading-[20px] tracking-normal text-[#758195]'
                />
              </div>

            

              <div>
                <Label htmlFor="editPermissionCategory" className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]">Category</Label>
                <Select
                  value={permissionFormData.category}
                  disabled
                  onValueChange={(value) =>
                    setPermissionFormData((prev) => ({
                      ...prev,
                      category: value as Permission['category'],
                    }))
                  }
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>

                  <SelectContent className="max-h-60 overflow-y-auto">
                    {permissionCategories.map((cat) => (
                      <SelectItem
                        key={cat}
                        value={cat}
                        className="mb-2 font-inter font-semibold text-[16px] leading-[100%] tracking-normal text-[#2C3E5D]"
                      >
                        {cat}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => { setShowEditPermissionDialog(false), resetPermissionForm() }} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-[#2C3E5D]">
                Cancel
              </Button>
              <Button onClick={handleEditPermission} className="font-inter font-semibold text-[14px] leading-[20px] tracking-normal text-white">
                Update Permission
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog> */}

        {/* Delete Permission Confirmation */}
        {/* <AlertDialog open={showDeletePermissionDialog} onOpenChange={setShowDeletePermissionDialog}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Delete Permission</AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to delete the permission "{permissionToDelete?.name}"?
                This action cannot be undone and will remove this permission from all roles that currently have it.
              </AlertDialogDescription>
              <AlertDialogDescription>
                Are you sure you want to delete the permission "{permissionToDelete?.name}"?
                {(permissionToDelete?.roleCount ?? 0) > 0
                  ? "This action cannot be undone and will remove this permission from all roles that currently have it."
                  : "This action cannot be undone."}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDeletePermission} className="bg-red-600 hover:bg-red-700">
                Delete Permission
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog> */}
      </div>
    </Layout>
  );
}